import { RecipeOld, RecipeCategoryTypes } from './recipes.model';
import { LARAVEL_IMPORT_YAML } from './recipes/backend/laravel';
import { NESTJS_IMPORT_YAML } from './recipes/backend/nestjs';
import { NODE_JS_IMPORT_YAML } from './recipes/runtimes/node-js';
import { BUN_IMPORT_YAML } from './recipes/runtimes/bun';
import { PHP_IMPORT_YAML } from './recipes/runtimes/php';
import { GO_IMPORT_YAML } from './recipes/runtimes/go';
import { JAVA_IMPORT_YAML } from './recipes/runtimes/java';
import { PYTHON_IMPORT_YAML } from './recipes/runtimes/python';
import { RUST_IMPORT_YAML } from './recipes/runtimes/rust';
import { DOTNET_IMPORT_YAML } from './recipes/runtimes/dotnet';
import { ASTRO_IMPORT_YAML } from './recipes/frontend/astro';
import { ASTRO_NODEJS_IMPORT_YAML } from './recipes/frontend/astro-nodejs';
import { ASTRO_STATIC_IMPORT_YAML } from './recipes/frontend/astro-static';
import { REMIX_NODEJS_IMPORT_YAML } from './recipes/frontend/remix-nodejs';
import { DJANGO_IMPORT_YAML } from './recipes/backend/django';
import { DENO_IMPORT_YAML } from './recipes/runtimes/deno';
import { SOLIDJS_IMPORT_YAML } from './recipes/frontend/solidjs';
import { SOLIDJS_NODEJS_IMPORT_YAML } from './recipes/frontend/solidjs-nodejs';
import { SOLIDJS_STATIC_IMPORT_YAML } from './recipes/frontend/solidjs-static';
import { VUE_IMPORT_YAML } from './recipes/frontend/vue';
import { GHOST_IMPORT_YAML } from './recipes/project-utility/ghost';
import { PAYLOAD_IMPORT_YAML } from './recipes/project-utility/payload';
import { MEDUSA_IMPORT_YAML, MEDUSA_NEXT_DEV_IMPORT_YAML, MEDUSA_NEXT_PROD_IMPORT_YAML } from './recipes/project-utility/medusa';
import { NETTE_IMPORT_YAML } from './recipes/backend/nette';
import { CONTRIBUTTE_IMPORT_YAML } from '@zerops/models/recipes/recipes/backend/contributte';
import { SVELTE_IMPORT_YAML } from '@zerops/models/recipes/recipes/frontend/svelte';
import { SVELTE_STATIC_IMPORT_YAML } from '@zerops/models/recipes/recipes/frontend/svelte-static';
import { SVELTE_NODEJS_IMPORT_YAML } from '@zerops/models/recipes/recipes/frontend/svelte-nodejs';
import { ECHO_IMPORT_YAML } from '@zerops/models/recipes/recipes/backend/echo';
import { QWIK_IMPORT_YAML } from '@zerops/models/recipes/recipes/frontend/qwik';
import { QWIK_NODEJS_IMPORT_YAML } from '@zerops/models/recipes/recipes/frontend/qwik-nodejs';
import { QWIK_STATIC_IMPORT_YAML } from '@zerops/models/recipes/recipes/frontend/qwik-static';
// import { DISCORD_BUN_IMPORT_YAML } from './recipes/platform-bots/discord-bun';
// import { DISCORD_NODEJS_IMPORT_YAML } from './recipes/platform-bots/discord-nodejs';
// import { DISCORD_PY_IMPORT_YAML } from './recipes/platform-bots/discord-py';
import { NEXTJS_IMPORT_YAML } from './recipes/frontend/nextjs';
import { NEXTJS_NODEJS_IMPORT_YAML } from './recipes/frontend/nextjs-nodejs';
import { NEXTJS_STATIC_IMPORT_YAML } from './recipes/frontend/nextjs-static';
import { ANALOG_IMPORT_YAML } from './recipes/frontend/analog';
import { ANALOG_NODEJS_IMPORT_YAML } from './recipes/frontend/analog-nodejs';
import { ANALOG_STATIC_IMPORT_YAML } from './recipes/frontend/analog-static';
import { REACT_IMPORT_YAML } from './recipes/frontend/react';
import { REACT_NODEJS_IMPORT_YAML } from './recipes/frontend/react-nodejs';
import { REACT_STATIC_IMPORT_YAML } from './recipes/frontend/react-static';
import { SPRING_IMPORT_YAML } from './recipes/backend/spring';
import { NUXT_STATIC_IMPORT_YAML } from './recipes/frontend/nuxt-static';
import { NUXT_NODEJS_IMPORT_YAML } from './recipes/frontend/nuxt-nodejs';
import { NUXT_IMPORT_YAML } from './recipes/frontend/nuxt';
import { SYMFONY_IMPORT_YAML } from './recipes/backend/symfony';
import { GLEAM_IMPORT_YAML } from './recipes/runtimes/gleam';
import { ANGULAR_STATIC_IMPORT_YAML } from './recipes/frontend/angular-static';
import { ELIXIR_IMPORT_YAML } from './recipes/runtimes/elixir';
import { PHOENIX_IMPORT_YAML } from './recipes/backend/phoenix';
import { DIRECTUS_IMPORT_YAML } from './recipes/frontend/directus';
import { RUBY_IMPORT_YAML } from './recipes/runtimes/ruby';

// LARAVEL LANDING PAGE
import { LARAVEL_MINIMAL_LOCAL_IMPORT_YAML } from './recipes/lp-laravel/laravel-minimal-local';
import { LARAVEL_MINIMAL_DEVEL_IMPORT_YAML } from './recipes/lp-laravel/laravel-minimal-devel';
import { LARAVEL_MINIMAL_PROD_IMPORT_YAML } from './recipes/lp-laravel/laravel-minimal-prod';

import { LARAVEL_JETSTREAM_LOCAL_IMPORT_YAML } from './recipes/lp-laravel/laravel-jetstream-local';
import { LARAVEL_JETSTREAM_DEVEL_IMPORT_YAML } from './recipes/lp-laravel/laravel-jetstream-devel';
import { LARAVEL_JETSTREAM_PROD_IMPORT_YAML } from './recipes/lp-laravel/laravel-jetstream-prod';

import { TWILLCMS_LOCAL_IMPORT_YAML } from './recipes/lp-laravel/twillcms-local';
import { TWILLCMS_DEVEL_IMPORT_YAML } from './recipes/lp-laravel/twillcms-devel';
import { TWILLCMS_PROD_IMPORT_YAML } from './recipes/lp-laravel/twillcms-prod';

import { FILAMENT_LOCAL_IMPORT_YAML } from './recipes/lp-laravel/filament-local';
import { FILAMENT_DEVEL_IMPORT_YAML } from './recipes/lp-laravel/filament-devel';
import { FILAMENT_PROD_IMPORT_YAML } from './recipes/lp-laravel/filament-prod';

import { RAG_STARTER_IMPORT_YAML } from './recipes/other/rag-starter';


export const RECIPES: RecipeOld[] = [
  // nodejs
  {
    id: 'nodejs',
    recipeId: 'zeropsio/recipe-nodejs',
    slug: 'nodejs',
    tag: 'Node.js',
    logo: 'nodejs',
    icon: undefined,
    title: 'Node.js',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: NODE_JS_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-nodejs' }],
    desc: `This is the most bare-bones example of Node.js app running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Node.js / Express.js app running on a load balanced <strong>Zerops Node.js</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Node.js service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Node.js production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Use more advanced logging lib, such as <a target="_blank" href="https://github.com/winstonjs/winston">winston</a></li>
      </ul>
    </section>
    `,
  },
  // bun
  {
    id: 'bun',
    recipeId: 'zeropsio/recipe-bun',
    slug: 'bun',
    tag: 'Bun',
    logo: 'bun',
    icon: undefined,
    title: 'Bun',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: BUN_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-bun' }],
    desc: `This is the most bare-bones example of Bun app running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Bun app running on a load balanced <strong>Zerops Bun</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Node.js service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Bun production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Use more advanced logging lib, such as <a target="_blank" href="https://github.com/winstonjs/winston">winston</a></li>
      </ul>
    </section>
    `,
  },
  // deno
  {
    id: 'deno',
    recipeId: 'zeropsio/recipe-deno',
    slug: 'deno',
    tag: 'Deno',
    logo: 'deno',
    icon: undefined,
    title: 'Deno',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: DENO_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-deno' }],
    desc: `This is the most bare-bones example of Deno app running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Deno app running on a load balanced <strong>Zerops Deno</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Node.js service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Deno production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Use more advanced logging lib, such as <a target="_blank" href="https://github.com/deno-library/logger">Deno logger</a></li>
      </ul>
    </section>
    `,
  },
  // php
  {
    id: 'php',
    recipeId: 'zeropsio/recipe-php',
    slug: 'php',
    tag: 'PHP',
    logo: 'php',
    icon: undefined,
    title: 'PHP',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: PHP_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-php' }],
    desc: `This is the most bare-bones example of PHP running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>PHP 8.3</strong> app running on a load balanced <strong>Zerops Apache and Nginx</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the PHP service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>apacheapi/nginxapi</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available PHP production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Use more advanced logging lib, such as <a target="_blank" href="https://github.com/Seldaek/monolog">Monolog</a>, <a target="_blank" href="https://github.com/jbroadway/analog">Analog</a> or <a target="_blank" href="https://github.com/katzgrau/KLogger">KLogger</a></li>
      </ul>
    </section>
    `,
  },
  // go
  {
    id: 'go',
    recipeId: 'zeropsio/recipe-go',
    slug: 'go',
    tag: 'Golang',
    logo: 'go',
    icon: undefined,
    title: 'Go',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: GO_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-go' }],
    desc: `This is the most bare-bones example of Go running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Golang v1.22.</strong> app running on a load balanced <strong>Zerops GO</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the GO service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available GO production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Use more advanced logging lib, such as <a target="_blank" href="https://github.com/sirupsen/logrus">Logrus</a>, <a target="_blank" href="https://github.com/uber-go/zap">Zap</a> or <a target="_blank" href="https://github.com/rs/zerolog">ZeroLog</a></li>
      </ul>
    </section>
    `,
  },
  // java
  {
    id: 'java',
    recipeId: 'zeropsio/recipe-java',
    slug: 'java',
    tag: 'Java',
    logo: 'java',
    icon: undefined,
    title: 'Java',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: JAVA_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-java' }],
    desc: `This is the most bare-bones example of Java running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
      <section>
        <h2>Recipe features</h2>
        <ul>
          <li><strong>Java 17 Spring Boot</strong> app running on a load balanced <strong>Zerops Java</strong> service</li>
          <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
          <li>Healthcheck setup example</li>
          <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
          <li>Utilization of Zerops' built-in <strong>log management</strong></li>
        </ul>
      </section>

      <section>
        <h2>Production vs. development</h2>
        <p>Base of the recipe is ready for production, the difference comes down to:</p>
        <ul>
          <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
          <li>Use at least two containers for the GO service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
        </ul>
        <p>Further things to think about when running more complex, highly available GO production apps on Zerops:</p>
        <ul>
          <li>Containers are volatile - use Zerops object storage to store your files</li>
          <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
          <li>Implement more advanced logging, such as using <a target="_blank" href="http://www.slf4j.org/">SLF4J</a> with <a target="_blank" href="http://logback.qos.ch/">Logback</a></li>
        </ul>
      </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>Configure the application to <a target="_blank" href="https://github.com/zeropsio/recipe-java/blob/main/src/main/resources/application.properties#L11">listen on all network interfaces</a> (<em>server.address=0.0.0.0</em>) to ensure it's accessible within the Zerops environment</>
    </section>`,
  },
  // python
  {
    id: 'python',
    recipeId: 'zeropsio/recipe-python',
    slug: 'python',
    tag: 'Python',
    logo: 'python',
    icon: undefined,
    title: 'Python',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: PYTHON_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-python' }],
    desc: `This is the most bare-bones example of Python running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Python 3.12</strong> app running on a load balanced <strong>Zerops Python</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Python service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Python production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Use more advanced logging lib, such as <a target="_blank" href="https://github.com/sirupsen/logrus">Logrus</a>, <a target="_blank" href="https://github.com/uber-go/zap">Zap</a> or <a target="_blank" href="https://github.com/rs/zerolog">ZeroLog</a></li>
      </ul>
    </section>
    `,
  },
  // dotnet
  {
    id: 'dotnet',
    recipeId: 'zeropsio/recipe-dotnet',
    slug: 'dotnet',
    tag: '.NET',
    logo: 'dotnet',
    icon: undefined,
    title: '.NET',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: DOTNET_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-dotnet' }],
    desc: `This is the most bare-bones example of .NET running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>.NET 6</strong> app running on a load balanced <strong>Zerops .NET</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the .NET service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available .NET production apps on Zerops:</p>
      <ul>
+        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Use more advanced logging lib, such as <a target="_blank" href="https://github.com/NLog/NLog">NLog</a> or <a target="_blank" href="https://github.com/serilog/serilog">serilog</a></li>
      </ul>
    </section>
    `,
  },
  // rust
  {
    id: 'rust',
    recipeId: 'zeropsio/recipe-rust',
    slug: 'rust',
    tag: 'Rust',
    logo: 'rust',
    icon: undefined,
    title: 'Rust',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: RUST_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-rust' }],
    desc: `This is the most bare-bones example of Rust running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Rust 1.78</strong> app running on a load balanced <strong>Zerops Rust</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Rust service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Rust production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Use more advanced logging lib, such as <a target="_blank" href="https://github.com/slog-rs/slog">slog</a></li>
      </ul>
    </section>
    `,
  },
  // gleam
  {
    id: 'gleam',
    recipeId: 'zeropsio/recipe-gleam',
    slug: 'gleam',
    tag: 'Gleam',
    logo: 'gleam',
    icon: undefined,
    title: 'Gleam',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: GLEAM_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-gleam' }],
    desc: `This is the most bare-bones example of Gleam running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Wisp + Mist</strong> app running on a load balanced <strong>Zerops Gleam</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup endpoint at <em>/status</em></li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Gleam service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Gleam production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (Valkey) for caching, storing sessions and pub/sub messaging</li>
      </ul>
    </section>
    `,
  },
  // ruby
  {
    id: 'ruby',
    recipeId: 'zeropsio/recipe-ruby',
    slug: 'ruby',
    tag: 'Ruby',
    logo: 'ruby',
    icon: undefined,
    title: 'Ruby',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: RUBY_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-ruby' }],
    desc: `This is the most bare-bones example of Ruby running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Ruby</strong> with <strong>Sinatra</strong> on a load balanced <strong>Zerops Ruby</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Healthcheck setup example via <em>/status</em> endpoint</li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system through dotenv</li>
        <li>Utilization of Zerops' built-in <strong>log management</strong> with various log levels</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Ruby service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Ruby production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (KeyDB) for caching, storing sessions and pub/sub messaging</li>
        <li>Consider using Puma or Unicorn as production-ready application servers</li>
        <li>Use more advanced logging tools such as the Ruby port of structured logging libraries</li>
      </ul>
    </section>
    `,
  },
  // elixir
  {
    id: 'elixir',
    recipeId: 'zeropsio/recipe-elixir',
    slug: 'elixir',
    tag: 'Elixir',
    logo: 'elixir',
    icon: undefined,
    title: 'Elixir',
    listed: true,
    category: RecipeCategoryTypes.Runtimes,
    importYaml: ELIXIR_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-elixir' }],
    desc: `This is the most bare-bones example of Elixir running on Zerops — as few libraries as possible, just a simple endpoint with connnect, read and write to a Zerops PostgreSQL database.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Plug</strong> + <strong>Cowboy</strong> HTTP server running on a load balanced <strong>Zerops Elixir</strong> service</li>
        <li>Zerops <strong>PostgreSQL</strong> service as database</li>
        <li>Built with <code>plug_cowboy</code> for HTTP server functionality</li>
        <li><strong>Ecto</strong> for database interactions</li>
        <li>Health check endpoint at <code>/status</code></li>
        <li>Utilization of Zerops' built-in <strong>environment variables</strong> system</li>
        <li>JSON response handling with <strong>Jason</strong></li>
    </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Elixir service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Elixir production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Use Zerops Redis (Valkey) for caching, storing sessions and pub/sub messaging</li>
      </ul>
    </section>
    `,
  },
  // react
  {
    id: 'react',
    recipeId: 'zeropsio/recipe-react',
    slug: 'react',
    tag: 'React',
    logo: 'react',
    icon: undefined,
    title: 'React SSR + Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: REACT_IMPORT_YAML,
    repository: [
      {
        name: 'SSR',
        repository: 'https://github.com/zeropsio/recipe-react-nodejs',
      },
      {
        name: 'Static',
        repository: 'https://github.com/zeropsio/recipe-react-static',
      },
    ],
    desc: `<a target="_blank" href="https://react.dev/">React</a> is a JavaScript web library for building fast, dynamic full-stack web apps with both server-side rendering and static site generation. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running React apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>React + Vite + Express</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
        <li>Latest version of <strong>React + Vite</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default SSG installation</h2>
      <p>If you want to modify your existing React app to efficiently run on Zerops, no changes are needed in the codebase beyond the standard installation. Just add the <a href="https://github.com/zeropsio/recipe-react-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to your repository.</p>
    </section>
    <section>
      <h2>Changes made over the default SSR installation</h2>
      <p>If you want to modify your existing React app to efficiently run on Zerops, Follow the given Steps below:</p>
      <ul>
      <li>You'll need to setup a <a href="https://github.com/zeropsio/recipe-react-nodejs/blob/main/server.js" target="_blank">server.js</a> file.</li>
      <li>Make sure you have the used packages check the <a href="https://github.com/zeropsio/recipe-react-nodejs/blob/main/package.json" target="_blank">package.json</a> to know the used packages.</li>
      <li>Check the scripts used in <a href="https://github.com/zeropsio/recipe-react-nodejs/blob/main/package.json" target="_blank">package.json</a>. Make sure you have the following scripts.</li>
      </ul>
      <p>Now, just add the <a href="https://github.com/zeropsio/recipe-react-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project.</p>
    </section>`,
  },
  // react-nodejs
  {
    id: 'react-nodejs',
    recipeId: 'zeropsio/recipe-react-nodejs',
    slug: 'react-nodejs',
    tag: 'React',
    logo: 'react',
    icon: undefined,
    title: 'React SSR',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: REACT_NODEJS_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-react-nodejs' },
    ],
    desc: `<a target="_blank" href="https://react.dev/">React</a> is a JavaScript web library for building fast, dynamic full-stack web apps with both server-side rendering and static site generation. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running React apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>React + Vite + Express</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing React app to efficiently run on Zerops, Follow the given Steps below:</p>
      <ul>
      <li>You'll need to setup a <a href="https://github.com/zeropsio/recipe-react-nodejs/blob/main/server.js" target="_blank">server.js</a> file.</li>
      <li>Make sure you have the used packages check the <a href="https://github.com/zeropsio/recipe-react-nodejs/blob/main/package.json" target="_blank">package.json</a> to know the used packages.</li>
      <li>Check the scripts used in <a href="https://github.com/zeropsio/recipe-react-nodejs/blob/main/package.json" target="_blank">package.json</a>. Make sure you have the following scripts.</li>
      </ul>
      <p>Now, just add the <a href="https://github.com/zeropsio/recipe-react-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project.</p>
    </section>
    `,
  },
  // react-static
  {
    id: 'react-static',
    recipeId: 'zeropsio/recipe-react-static',
    slug: 'react-static',
    tag: 'React',
    logo: 'react',
    icon: undefined,
    title: 'React Static',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: REACT_STATIC_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-react-static' },
    ],
    desc: `<a target="_blank" href="https://react.dev/">React</a> is a JavaScript web library for building fast, dynamic full-stack web apps with both server-side rendering and static site generation. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running React apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>React + Vite</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing React app to efficiently run on Zerops, no changes are needed in the codebase beyond the standard installation. Just add the <a href="https://github.com/zeropsio/recipe-react-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to your repository.</p>
    </section>
    `,
  },
  // vue
  {
    id: 'vue',
    recipeId: 'zeropsio/recipe-vue',
    slug: 'vue',
    tag: 'Vue',
    logo: 'vue',
    icon: undefined,
    title: 'Vue.js',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: VUE_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-vue' }],
    desc: `Vue.js is an approachable, performant and versatile framework for building web user interfaces.Zerops makes deploying and running Vue.js a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <p>A <strong>Vue 3</strong> running on a load balanced <strong>Zerops Node.js</strong> service.</p>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add minContainers: 2 in recipe YAML in the app service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Vue app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a target="_blank" href="https://github.com/zeropsio/vue/blob/main/zerops.yml">zerops.yml</a> to your repository.</>
    </section>

    `,
  },
  // svelte
  {
    id: 'svelte',
    recipeId: 'zeropsio/recipe-svelte',
    slug: 'svelte',
    tag: 'Svelte',
    logo: 'svelte',
    icon: undefined,
    title: 'Svelte SSR + Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: SVELTE_IMPORT_YAML,
    repository: [
      {
        name: 'SSR',
        repository: 'https://github.com/zeropsio/recipe-svelte-nodejs',
      },
      {
        name: 'Static',
        repository: 'https://github.com/zeropsio/recipe-svelte-static',
      },
    ],
    desc: `<a href="https://kit.svelte.dev/">Sveltekit</a> is a framework for building robust, fast web applications using Svelte. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Sveltekit apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>SvelteKit</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
        <li>Latest version of <strong>SvelteKit</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing SvelteKit app to efficiently run on Zerops, follow these steps:</p>
      <ol>
        <li>Install the necessary adapter with:
          <pre>pnpm i -D @sveltejs/adapter-node</pre>
        </li>
        <li>Add the adapter to your <em>svelte.config.js</em> to enable SSG. Also, ensure you have <em>@sveltejs/vite-plugin-svelte</em> to avoid errors.
<pre>import adapter from '@sveltejs/adapter-node';
import { vitePreprocess } from '@sveltejs/vite-plugin-svelte';

/** @type {import('@sveltejs/kit').Config} */
const config = {
  kit: {
    adapter: adapter(),
  },
  preprocess: vitePreprocess(),
};

export default config;</pre>
        </li>
        <li>
        Only for static version - Add the prerender option to your root layout, for example, in src/routes/+layout.ts:
<pre>// export const ssr = false; default is false
export const prerender = true;</pre>
        </li>
        <li>
          Add the corresponding zerops.yml for <a href="https://github.com/zeropsio/recipe-svelte-nodejs/blob/main/zerops.yml" target="_blank">SSR</a>
           or <a href="https://github.com/zeropsio/recipe-svelte-static/blob/main/zerops.yml" target="_blank">static</a> version.
        </li>
      </ol>

    </section>`,
  },
  // svelte-nodejs
  {
    id: 'svelte-nodejs',
    recipeId: 'zeropsio/recipe-svelte-nodejs',
    slug: 'svelte-nodejs',
    tag: 'Svelte',
    logo: 'svelte',
    icon: undefined,
    title: 'Svelte SSR',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: SVELTE_NODEJS_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-svelte-nodejs' },
    ],
    desc: `<a href="https://kit.svelte.dev/">Sveltekit</a> is a framework for building robust, fast web applications using Svelte. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Sveltekit apps, both server side rendered and static, a breeze. This recipe showcases the SSR version.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>SvelteKit</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing SvelteKit app to efficiently run on Zerops, follow these steps:</p>
      <ol>
        <li>Install the necessary adapter with:
          <pre>pnpm i -D @sveltejs/adapter-node</pre>
        </li>
        <li>Add the adapter to your <em>svelte.config.js</em> to enable SSG. Also, ensure you have <em>@sveltejs/vite-plugin-svelte</em> to avoid errors.
<pre>import adapter from '@sveltejs/adapter-node';
import { vitePreprocess } from '@sveltejs/vite-plugin-svelte';

/** @type {import('@sveltejs/kit').Config} */
const config = {
  kit: {
    adapter: adapter(),
  },
  preprocess: vitePreprocess(),
};

export default config;</pre>
        </li>
        <li>
          Add the corresponding zerops.yml for <a href="https://github.com/zeropsio/recipe-svelte-nodejs/blob/main/zerops.yml" target="_blank">SSR</a>
           or <a href="https://github.com/zeropsio/recipe-svelte-static/blob/main/zerops.yml" target="_blank">static</a> version.
        </li>
      </ol>

    </section>`,
  },
  // svelte-static
  {
    id: 'svelte-static',
    recipeId: 'zeropsio/recipe-svelte-static',
    slug: 'svelte-static',
    tag: 'Svelte',
    logo: 'svelte',
    icon: undefined,
    title: 'Svelte static',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: SVELTE_STATIC_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-svelte-static' },
    ],
    desc: `<a href="https://kit.svelte.dev/">Sveltekit</a> is a framework for building robust, fast web applications using Svelte. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Sveltekit apps, both server side rendered and static, a breeze. This recipe showcases the static version.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>SvelteKit</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing SvelteKit app to efficiently run on Zerops, follow these steps:</p>
      <ol>
        <li>Install the necessary adapter with:
          <pre>pnpm i -D @sveltejs/adapter-node</pre>
        </li>
        <li>Add the adapter to your <em>svelte.config.js</em> to enable SSG. Also, ensure you have <em>@sveltejs/vite-plugin-svelte</em> to avoid errors.
<pre>import adapter from '@sveltejs/adapter-node';
import { vitePreprocess } from '@sveltejs/vite-plugin-svelte';

/** @type {import('@sveltejs/kit').Config} */
const config = {
  kit: {
    adapter: adapter(),
  },
  preprocess: vitePreprocess(),
};

export default config;</pre>
        </li>
        <li>
        Add the prerender option to your root layout, for example, in src/routes/+layout.ts:
<pre>// export const ssr = false; default is false
export const prerender = true;</pre>
        </li>
        <li>
          Add the corresponding zerops.yml for <a href="https://github.com/zeropsio/recipe-svelte-nodejs/blob/main/zerops.yml" target="_blank">SSR</a>
           or <a href="https://github.com/zeropsio/recipe-svelte-static/blob/main/zerops.yml" target="_blank">static</a> version.
        </li>
      </ol>

    </section>`,
  },
  // nextjs
  {
    id: 'nextjs',
    recipeId: 'zeropsio/recipe-nextjs',
    slug: 'nextjs',
    tag: 'Next.js',
    logo: 'nextjs',
    icon: undefined,
    title: 'Next.js SSR + Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: NEXTJS_IMPORT_YAML,
    repository: [
      {
        name: 'SSR',
        repository: 'https://github.com/zeropsio/recipe-nextjs-nodejs'
      },
      {
        name: 'Static',
        repository: 'https://github.com/zeropsio/recipe-nextjs-static'
      }
    ],
    desc: `<a href="https://nextjs.org/" target="_blank">Next.js</a> is a React framework for fast, dynamic full-stack web apps with both server-side rendering and static site generation. <a href="https://zerops.io/" target="_blank">Zerops</a> makes deploying and running Next.js apps, both server side rendered and static, a breeze.</a>`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Next.js 14+</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
        <li>Latest version of <strong>Next.js 14+</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default SSR installation</h2>
      <p>If you want to modify your existing Remix app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a target="_blank" href="https://github.com/zeropsio/recipe-nextjs-nodejs/blob/main/zerops.yml">zerops.yml</a> to your repository.</p>
    </section>
    <section>
      <h2>Changes made over the default SSG installation</h2>
      <p>If you want to modify your existing Next.js app to efficiently run on Zerops, follow this step:</p>
      <ol>
        <li>Go to <em>next.config.mjs</em> and add <em>output: 'export'</em> to nextConfig.
          <pre>/const nextConfig = { output: 'export', };</pre>
        </li>
        <li>Now, just add the <a href="https://github.com/zeropsio/recipe-nextjs-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
      </ol>
    </section>
    `
  },
  // nextjs-nodejs
  {
    id: 'nextjs-nodejs',
    recipeId: 'zeropsio/recipe-nextjs-nodejs',
    slug: 'nextjs-nodejs',
    tag: 'Next.js',
    logo: 'nextjs',
    icon: undefined,
    title: 'Next.js SSR',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: NEXTJS_NODEJS_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-nextjs-nodejs' }],
    desc: `<a href="https://nextjs.org/" target="_blank">Next.js</a> is a React framework for fast, dynamic full-stack web apps with both server-side rendering and static site generation. <a href="https://zerops.io/" target="_blank">Zerops</a> makes deploying and running Next.js apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Next.js 14+</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Next.js app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a target="_blank" href="https://github.com/zeropsio/recipe-nextjs-nodejs/blob/main/zerops.yml">zerops.yml</a> to your repository.</p>
    </section>
    `
  },
  // nextjs-static
  {
    id: 'nextjs-static',
    recipeId: 'zeropsio/recipe-nextjs-static',
    slug: 'nextjs-static',
    tag: 'Next.js',
    logo: 'nextjs',
    icon: undefined,
    title: 'Next.js SSG',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: NEXTJS_STATIC_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-nextjs-static' }],
    desc: `<a href="https://nextjs.org/" target="_blank">Next.js</a> is a React framework for fast, dynamic full-stack web apps with both server-side rendering and static site generation. <a href="https://zerops.io/" target="_blank">Zerops</a> makes deploying and running Next.js apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Next.js 14+</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Next.js app to efficiently run on Zerops, follow this step:</p>
      <ol>
        <li>Go to <em>next.config.mjs</em> and add <em>output: 'export'</em> to nextConfig.
          <pre>/const nextConfig = { output: 'export', };</pre>
        </li>
        <li>Now, just add the <a href="https://github.com/zeropsio/recipe-nextjs-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
      </ol>
    </section>
    `
  },
  // remix-nodejs
  {
    id: 'remix-nodejs',
    recipeId: 'zeropsio/recipe-remix-nodejs',
    slug: 'remix-nodejs',
    tag: 'Remix',
    logo: 'remix',
    icon: undefined,
    title: 'Remix (Node.js)',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: REMIX_NODEJS_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-remix-nodejs' },
    ],
    desc: `Remix is a framework for fast, dynamic web apps with server-side rendering. Zerops simplifies deployment, offering automatic scaling, optional caching, logging integrations, and easy setup for additional services, letting you focus on development without infrastructure hassles.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <p>A Node.js version of <strong>Remix v2</strong> running on a load balanced <strong>Zerops Node.js</strong> service.</p>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add minContainers: 2 in recipe YAML in the app service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>

      <p>Additionally, you might want to consider:</p>
      <ul>
        <li>Using <strong>Zerops Redis</strong> service for caching</li>
        <li>Setting up <a target="_blank" href="https://github.com/winstonjs/winston">Winston</a> for advanced and structured logging</li>
      </ul>

    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Remix app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a target="_blank" href="https://github.com/zeropsio/recipe-remix-nodejs/blob/main/zerops.yml">zerops.yml</a> to your repository.</>
    </section>
    `
  },
  // astro
  {
    id: 'astro',
    recipeId: 'zeropsio/recipe-astro',
    slug: 'astro',
    tag: 'Astro',
    logo: 'astro',
    icon: undefined,
    title: 'Astro SSR + Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: ASTRO_IMPORT_YAML,
    repository: [
      {
        name: 'SSR',
        repository: 'https://github.com/zeropsio/recipe-astro-nodejs',
      },
      {
        name: 'Static',
        repository: 'https://github.com/zeropsio/recipe-astro-static',
      },
    ],
    desc: `Astro is a server-first JavaScript web framework that supports every major UI framework, it's optimized for building fast, content-driven websites. Zerops makes deploying and running Astro sites, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>SSR version of <strong>Astro 4.1</strong> running on a load balanced <strong>Zerops Node.js</strong> service.</li>
        <li>Static version of <strong>Astro 4.1</strong> running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>staticapp</em> and <em>ssrapp</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <ul>
        <li>For the SSR version, if you haven't already, add <em>@astrojs/node</em> package and implement it in your <a target="_blank" href="https://github.com/zeropsio/recipe-astro-nodejs/blob/main/astro.config.mjs#L15-L17">astro.config.mjs</a>. No changes needed for the static version.</li>
        <li>Add <strong>zerops.yml</strong> to your repository, <a target="_blank" href="https://github.com/zeropsio/recipe-astro-nodejs/blob/main/zerops.yml">version for SSR</a>, <a target="_blank" href="https://github.com/zeropsio/recipe-astro-static/blob/main/zerops.yml">version for static</a>.</li>
      </ul>
    </section>
    `,
  },
  // astro-nodejs
  {
    id: 'astro-nodejs',
    recipeId: 'zeropsio/recipe-astro-nodejs',
    slug: 'astro-nodejs',
    tag: 'Astro',
    logo: 'astro',
    icon: undefined,
    title: 'Astro SSR',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: ASTRO_NODEJS_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-astro-nodejs' },
    ],
    desc: `Astro is a server-first JavaScript web framework that supports every major UI framework, it's optimized for building fast, content-driven websites. Zerops makes deploying and running Astro sites, both server side rendered and static, a breeze. This recipe showcases the SSR version.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <p>SSR version of <strong>Astro 4.1</strong> running on a load balanced <strong>Zerops Node.js</strong> service.</p>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Astro site to efficiently run on Zerops, these are the general steps we took:</p>
      <ul>
        <li>If you haven't already, add <em>@astrojs/node</em> package and implement it in your <a target="_blank" href="https://github.com/zeropsio/recipe-astro-nodejs/blob/main/astro.config.mjs#L15-L17">astro.config.mjs</a>. No changes needed for the static version</li>
        <li>Add <a target="_blank" href="https://github.com/zeropsio/recipe-astro-nodejs/blob/main/zerops.yml">zerops.yml</a> to your repository</li>
      </ul>
    </section>
    `,
  },
  // astro-static
  {
    id: 'astro-static',
    recipeId: 'zeropsio/recipe-astro-static',
    slug: 'astro-static',
    tag: 'Astro',
    logo: 'astro',
    icon: undefined,
    title: 'Astro static',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: ASTRO_STATIC_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-astro-static' },
    ],
    desc: `Astro is a server-first JavaScript web framework that supports every major UI framework, it's optimized for building fast, content-driven websites. Zerops makes deploying and running Astro sites, both server side rendered and static, a breeze. This recipe showcases the static version.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <p>SSR version of <strong>Astro 4.1</strong> running on <strong>Zerops Static</strong> service.</p>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Astro Static site to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a target="_blank" href="https://github.com/zeropsio/recipe-astro-static/blob/main/zerops.yml">zerops.yml</a> to your repository.</p>
    </section>
    `,
  },
  // solidjs
  {
    id: 'solidjs',
    recipeId: 'zeropsio/recipe-solidjs',
    slug: 'solidjs',
    tag: 'Solid',
    logo: 'solid',
    icon: undefined,
    title: 'Solid SSR + Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: SOLIDJS_IMPORT_YAML,
    repository: [
      {
        name: 'SSR',
        repository: 'https://github.com/zeropsio/recipe-solidjs-nodejs',
      },
      {
        name: 'Static',
        repository: 'https://github.com/zeropsio/recipe-solidjs-static',
      },
    ],
    desc: `Solid is a declarative Javascript library for creating fast, dynamic web apps with server-side rendering. Zerops makes deploying and running Astro sites, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest SSR Solid version generated with <a target="_blank" href="https://start.solidjs.com/">SolidStart</a> running on a load balanced <strong>Zerops Node.js</strong> service</li>
        <li>Latest Static Solid version generated with <a target="_blank" href="https://start.solidjs.com/">SolidStart</a> running on <strong>Zerops Static</strong> service</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>staticapp</em> and <em>ssrapp</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>

      <p>Additionally for the SSR version you might want to consider setting up <a target="_blank" href="https://github.com/winstonjs/winston">Winston</a> for advanced and structured logging.</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Solid app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <strong>zerops.yml</strong> to your repository,
       <a target="_blank" href="https://github.com/zeropsio/recipe-solidjs-nodejs/blob/main/zerops.yml">version for SSR</a>, <a target="_blank" href="https://github.com/zeropsio/recipe-solidjs-static/blob/main/zerops.yml">version for static</a>.</li>
      </p>
    </section>
    `,
  },
  // solidjs-nodejs
  {
    id: 'solidjs-nodejs',
    recipeId: 'zeropsio/recipe-solidjs-nodejs',
    slug: 'solidjs-nodejs',
    tag: 'Solid',
    logo: 'solid',
    icon: undefined,
    title: 'Solid SSR',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: SOLIDJS_NODEJS_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-solidjs-nodejs' },
    ],
    desc: `Solid is a declarative Javascript library for creating fast, dynamic web apps with server-side rendering. Zerops makes deploying and running Solid.js apps, both server side rendered and static, a breeze. This recipe showcases the SSR version.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest Solid version generated with <a taget="_blank" href="https://start.solidjs.com/">SolidStart</a> running on a load balanced <strong>Zerops Node.js</strong> service</li>
        <li>Server Side Rendering (SSR) with Vinxi</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>

      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>

      <p>Additionally for you might want to consider setting up <a target="_blank" href="https://github.com/winstonjs/winston">Winston</a> for advanced and structured logging.</p>

    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Solid app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a target="_blank" href="https://github.com/zeropsio/recipe-solidjs-nodejs/blob/main/zerops.yml">zerops.yml</a> to your repository.</p>
    </section>
    `,
  },
  // solidjs-static
  {
    id: 'solidjs-static',
    recipeId: 'zeropsio/recipe-solidjs-static',
    slug: 'solidjs-static',
    tag: 'Solid',
    logo: 'solid',
    icon: undefined,
    title: 'Solid Static',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: SOLIDJS_STATIC_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-solidjs-static' },
    ],
    desc: `Solid is a declarative Javascript library for creating fast, dynamic web apps with server-side rendering. Zerops makes deploying and running Solid.js apps, both server side rendered and static, a breeze. This recipe showcases the static version.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest Solid version generated with <a taget="_blank" href="https://start.solidjs.com/">SolidStart</a> running on <strong>Zerops Static</strong> service</li>
        <li>Static Site Generation (SSG) with Vite.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>

      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>

    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Solid app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a target="_blank" href="https://github.com/zeropsio/recipe-solidjs-static/blob/main/zerops.yml">zerops.yml</a> to your repository.</p>
    </section>
    `,
  },
  // nestjs
  {
    id: 'nestjs',
    recipeId: 'zeropsio/recipe-nestjs',
    slug: 'nestjs',
    tag: 'Nest.js',
    logo: 'nestjs',
    icon: undefined,
    title: 'Nest.js',
    listed: true,
    category: RecipeCategoryTypes.Backend,
    importYaml: NESTJS_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-nestjs' }],
    desc: `<a href="https://nestjs.com" target="_blank">Nest.js</a> is an amazing and popular Node.js framework. This recipe aims to showcase, through a simple file upload demo application, advanced concepts that unlock the scalebility powers of Nest.js.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Load balanced Nest.js API running on <strong>Zerops Node.js</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Zerops <strong>Object Storage</strong> (S3 compatible) service as file system</li>
        <li><strong>Idempotent</strong> TypeORM database migrations setup</li>
        <li>Logs set up to use <strong>syslog</strong> and accessible through Zerops GUI</li>
        <li>Utilization of Zerops built-in <strong>environment variables</strong> system</li>
        <li><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a> as <strong>SMTP mock server</strong></li>
        <li><a href="https://www.adminer.org" target="_blank">Adminer</a> for <strong>quick database management</strong> tool</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Nest.js service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
        <li>Use production-ready third-party SMTP server instead of Mailpit (change <em>SMTP_*</em> secret variables in recipe YAML, <em>api</em> service section)</li>
        <li>Disable public access to Adminer or remove it altogether (remove service adminer from recipe YAML)</li>
      </ul>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your Nest.js existing app to efficiently run on Zerops, these are the general steps we took:</p>
      <ul>
        <li>Add <a href="https://github.com/zeropsio/recipe-nestjs/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository, our example includes health checks and idempotent migrations</li>
        <li>Utilize Zerops environment variables management to securely pass <a href="https://github.com/zeropsio/recipe-nestjs/blob/main/src/config/db.config.ts#L8-L12" target="_blank">environment variables</a> to your app</li>
        <li>Add multer, aws-sdk packages and <a href="https://github.com/zeropsio/recipe-nestjs/blob/main/src/file/file.service.ts#L26-L36" target="_blank">utilize them</a> to upload files to S3 compatible Zerops object storage</li>
      </ul>
    </section>
    `,
  },
  // echo
  {
    id: 'echo',
    recipeId: 'zeropsio/recipe-echo',
    slug: 'echo',
    tag: 'Echo',
    logo: 'echo',
    icon: undefined,
    title: 'Echo',
    listed: true,
    category: RecipeCategoryTypes.Backend,
    importYaml: ECHO_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-echo' }],
    desc: `  <a href="https://echo.labstack.com/" target="_blank">Echo</a> is a high performance, extensible, minimalist Go web framework. This recipe aims to showcase a basic Echo server-side rendered web app and how to integrate it with <a href="https://zerops.io" target="_blank">Zerops</a>, all through a simple file upload demo application.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Load balanced</strong> Echo web app running on clean <strong>Zerops Alpine</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Zerops <strong>Object Storage</strong> (S3 compatible) service file storage</li>
        <li>Zerops <strong>KeyDB 6</strong> service as Redis-compatible session storage</li>
        <li>Cloud-ready <strong>database migration</strong> and initial <strong>data seeding</strong></li>
        <li>Utilization of Zerops built-in <strong>environment and secret variables</strong> system</li>
        <li>Logs accessible through Zerops GUI</li>
        <li><strong><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a></strong> as <strong>SMTP mock server</strong></li>
        <li><strong><a href="https://www.adminer.org" target="_blank">Adminer</a></strong> for <strong>quick database management</strong> tool</li>
        <li>Unlocked development experience:
          <ul>
            <li>Access to database and mail mock through Zerops project VPN (<em>zcli vpn up</em>)</li>
            <li>Prepared <em>.env.dist</em> file (<em>cp .env.dist .env</em> and change ***** secrets found in Zerops GUI)</li>
            <li>Run <em>npm install</em> to be able to re-build <em>tailwind.css</em> (<em>npm run build</em>)</li>
            <li>Optional: install and use auto-reloading feature <a href="https://github.com/air-verse/air" target="_blank">air</a></li>
          </ul>
        </li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use highly available version of the KeyDB store (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>redis</em> service section)</li>
        <li>Use at least two containers for Echo service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>app</em> service section)</li>
        <li>Use production-ready third-party SMTP server instead of Mailpit (change <em>MAIL_</em> secret variables in recipe YAML <em>app</em> service)</li>
        <li>Disable public access to Adminer or remove it altogether (remove service <em>adminer</em> from recipe YAML)</li>
        <li>Secure cookies with <em>Domain</em> attribute set to your domain</li>
      </ul>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Echo app to efficiently run on Zerops, these are the general steps we took:</p>
      <ul>
        <li>Use <em>os.Stdout</em> as logger output</li>
        <li>Disable HTTPS termination, since the app will run behind our automatic SSL load balancer proxy</li>
      </ul>
    </section>`,
  },
  // laravel
  {
    id: 'laravel',
    recipeId: 'zeropsio/recipe-laravel-jetstream',
    slug: 'laravel',
    tag: 'Laravel',
    logo: 'laravel',
    icon: undefined,
    category: RecipeCategoryTypes.Backend,
    importYaml: LARAVEL_IMPORT_YAML,
    listed: true,
    title: 'Laravel Jetstream',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-laravel-jetstream' },
    ],
    desc: `<a href="https://jetstream.laravel.com/introduction.html" target="_blank">Laravel Jetstream</a> is an advanced starter kit by Laravel. Zerops recipe for Jetstream includes all the advanced functionality — session and cache stored in Redis and files stored in Object Storage, this makes it perfectly suitable for production of any size.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Load balanced Laravel + Inertia.js running on <strong>Zerops PHP + nginx</strong> service</a>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Zerops KeyDB (<strong>Redis</strong>) service for session and cache</li>
        <li>Zerops <strong>Object Storage</strong> (S3 compatible) service as file system</li>
        <li>Proper setup for Laravel <strong>cache</strong>, <strong>optimization</strong> and <strong>database migrations</strong></li>
        <li>Logs set up to use <strong>syslog</strong> and accessible through Zerops GUI</li>
        <li>Utilization of Zerops built in <strong>environment variables</strong> system</li>
        <li><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a> as <strong>SMTP mock server</strong></li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>

      <p>Base of the recipe is ready for production, the difference comes down to:</p>

      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML <em>db</em> service)</li>
        <li>Use at least two containers for Jetstream service to achieve high reliability, resilience (add <em>minContainers: 2</em> in recipe YAML <em>app</em> service)</li>
        <li>Use production-ready third party SMTP server instead of Mailpit (change <em>MAIL_*</em> secret variables in recipe YAML <em>app</em> service)</li>
      </ul>

    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Laravel/Jetstream app to efficiently run on Zerops, these are the general steps we took:</p>

      <ul>
        <li>Add <a href="https://github.com/zeropsio/recipe-laravel-jetstream/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository, our example includes idempotent migrations, caching and optimized build process</li>
        <li>Add <a href="https://github.com/zeropsio/recipe-laravel-jetstream/blob/main/composer.json#L14" target="_blank">league/flysystem-aws-s3-v3</a> to your composer.json to support Object Storage file system
        <li>Setup <a href="https://github.com/zeropsio/recipe-laravel-jetstream/blob/main/config/jetstream.php#L79" target="_blank">Jetstream config</a> to use object storage for file system</li>
        <li>Utilize Zerops <a href="https://github.com/zeropsio/recipe-laravel-jetstream/blob/main/zerops.yml#L25-L75" target="_blank">environment variables</a> and <a href="https://github.com/zeropsio/recipe-laravel-jetstream/blob/main/zerops-project-import.yml#L12-L16" target="_blank">secrets</a> to setup S3 for file system, Redis for cache and sessions, and trusted proxies to work with reverse proxy load balancer</li>
      </ul>
    </section>
    `,
  },
  // strapi
  {
    id: 'strapi',
    recipeId: 'zeropsio/recipe-strapi',
    slug: 'strapi',
    tag: 'Strapi',
    logo: 'strapi',
    icon: undefined,
    disabled: true,
    listed: true,
    category: RecipeCategoryTypes.ProjectUtility,
    importYaml: NESTJS_IMPORT_YAML,
    desc: `Nest.js app. Deployed from GitHub repository <a href="https://github.com/zeropsio/recipe-nestjs">zeropsio/recipe-nestjs</a>`,
  },
  // django
  {
    id: 'django',
    recipeId: 'zeropsio/recipe-django',
    slug: 'django',
    tag: 'Django',
    logo: 'django',
    icon: undefined,
    title: 'Django',
    listed: true,
    category: RecipeCategoryTypes.Backend,
    importYaml: DJANGO_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-django' }],
    desc: `<a href="https://www.djangoproject.com/" target="_blank">Django</a> is a high-level Python web framework that encourages rapid development and clean, pragmatic design. This recipe aims to showcase an advanced cloud-like integration of Django in Zerops through a simple file upload demo application.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Load balanced</strong> Django web app running on <strong>Zerops Python</strong> service</li>
        <li>Served by production-ready application server <a href="https://gunicorn.org/" target="_blank">Gunicorn</a></li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Zerops <strong>Object Storage</strong> (S3 compatible) service as file system</li>
        <li>Automatic Django <strong>database migrations</strong>, <strong>static files collection</strong> and <strong>superuser seeding</strong></li>
        <li>Logs set up to use <strong>syslog</strong> and accessible through Zerops GUI</li>
        <li>Utilization of Zerops built-in <strong>environment variables</strong> system</li>
        <li><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a> as <strong>SMTP mock server</strong></li>
        <li><a href="https://www.adminer.org" target="_blank">Adminer</a> for <strong>quick database management</strong> tool</li>
        <li>
          Unlocked development experience:
          <ul>
            <li>Access to database and mail mock through Zerops project VPN (zcli vpn up)</li>
            <li>Prepared <em>.env.dist</em> file (<em>cp .env.dist .env</em> and change ***** secrets found in Zerops GUI)</li>
          </ul>
        </li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for the Django service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
        <li>Use production-ready third-party SMTP server instead of Mailpit (change <em>MAIL_*</em> secret variables in recipe YAML, <em>api</em> service section)</li>
        <li>Since the Django app will run behind our HTTP balancer proxy, add your domain/subdomains to <em>recipe/settings.py</em> <em>CSRF_TRUSTED_ORIGINS</em> setting or add <em>APP_DOMAIN</em> secret variable (in recipe YAML, <em>app</em> service section)<li>
        <li>Disable public access to Adminer or remove it altogether (remove service adminer from recipe YAML)</li>
      </ul>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Django app to efficiently run on Zerops, these are the general steps we took:</p>
      <ul>
        <li>Add <a href="https://github.com/zeropsio/recipe-django/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository, our example includes idempotent migrations, static files collection and optimized build process</li>
        <li>Run <em>pip install django-storages</em> and change storage settings section in your <em>project/settings.py</em> to support S3 compatible Object Storage file system (more info <a href="https://django-storages.readthedocs.io/en/latest/backends/amazon-S3.html" target="_blank">here</a>)</li>
        <li>Utilize Zerops <a href="https://github.com/zeropsio/recipe-django/blob/main/zerops.yml#L18-L30" target="_blank">environment variables</a> and <a href="https://github.com/zeropsio/recipe-django/blob/main/zerops.yml#L18-L30" target="_blank">secrets</a> to set up S3 for file system, database access, mailer and trusted hosts to work with reverse proxy load balancer</li>
        <li>Add init commands for your deployments to <a href="https://github.com/zeropsio/recipe-django/blob/main/zerops.yml#L34-L39" target="_blank">migrate database and collect static images</a></li>
      </ul>
    </section>
    `,
  },
  // nette
  {
    id: 'nette',
    recipeId: 'zeropsio/recipe-nette',
    slug: 'nette',
    tag: 'Nette',
    logo: 'nette',
    icon: undefined,
    category: RecipeCategoryTypes.Backend,
    importYaml: NETTE_IMPORT_YAML,
    listed: true,
    title: 'Nette',
    repository: [{ repository: 'https://github.com/zeropsio/recipe-nette' }],
    desc: `<a href="https://github.com/nette-examples/quickstart" target="_blank">Nette QuickStart</a> is a very simple web application based on Nette Framework. <a href="https://zerops.io" target="_blank">Zerops</a> recipe for Nette QuickStart includes session and cache stored in Redis, and PostgreSQL DB with <a href="https://nextras.org/migrations/" target="_blank">Nextras migrations</a>.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Nette running on a load balanced <strong>Zerops PHP + Nginx</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Zerops KeyDB (<strong>Redis</strong>) service for session and cache</li>
        <li>Setup for Nextras <strong>database migrations</strong> with automatic admin user creation</li>
        <li>Logs set up to use <strong>syslog</strong> and accessible through Zerops GUI</li>
        <li>Utilization of Zerops built-in <strong>environment variables</strong> system</li>
        <li><a href="https://www.adminer.org/en/" target="_blank">Adminer</a> for <strong>quick database management</strong> tool</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for Nette service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>app</em> service section)</li>
        <li>Disable public access to Adminer or remove it altogether (remove service <em>adminer</em> from recipe YAML)</li>
        <li>Set <em>APP_ENV</em> to <em>prod</em> in <em>envSecrets</em>, <em>app</em> section of import YAML</li>
      </ul>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Nette app to efficiently run on Zerops, these are the general steps we took:</p>
      <ul>
        <li>Add <a href="https://github.com/zeropsio/recipe-nette/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository, our example includes idempotent migrations, caching, and optimized build process</li>
        <li>Add <pre>$configurator->addDynamicParameters(['env' => getenv()]);</pre> to your <a href="https://github.com/zeropsio/recipe-nette/blob/main/app/Bootstrap.php:22" target="_blank">./app/Bootstrap.php</a> file to use env variables in your neon configuration files</li>
        <li>Set debug mode according to <em>APP_ENV</em> env variable in your <a href="https://github.com/zeropsio/recipe-nette/blob/main/app/Bootstrap.php:27" target="_blank">./app/Bootstrap.php</a> file</li>
        <li>Add <a href="https://github.com/nette/redis" target="_blank">nette/redis</a> to your composer.json to store sessions in Redis
          <ul>
            <li>configure it according to our <a href="https://github.com/zeropsio/recipe-nette/blob/main/config/common.neon#L44" target="_blank">./config/common.neon</a> file</li>
          </ul>
        </li>
        <li>Add <a href="https://github.com/nette/monolog" target="_blank">nette/monolog</a> to your composer.json to log into the syslog
          <ul>
            <li>utilize the following handler: <em>Monolog\\Handler\\SyslogHandler(app)</em> (see our <a href="https://github.com/MichalSalon/recipe-nette/blob/main/config/common.neon#L38" target="_blank">./config/common.neon</a>)</li>
          </ul>
        </li>
        <li>Add <a href="https://github.com/nextras/migrations/" target="_blank">nextras/migrations</a> to your composer.json to utilize automated DB migrations
          <ul>
            <li>create <em>./migrations</em> folder structure similar to this repo (we moved content of <em>database.sql</em> into it)</li>
            <li>SQLite (<em>./data/blog.sqlite</em>) was replaced by PostgreSQL database container</li>
          </ul>
        </li>
      </ul>
    </section>

    <section>
      <h2>Additional info</h2>
      <p>Admin login for this recipe is <em>admin</em> with automatically generated password, which can be found under <em>ADMIN_PASSWORD</em> name in Zerops Environment variables section of <em>app</em> service.</p>
    </section>
    `,
  },
  // contributte
  {
    id: 'contributte',
    recipeId: 'zeropsio/recipe-nette-contributte',
    slug: 'contributte',
    tag: 'Contributte',
    logo: 'contributte',
    icon: undefined,
    category: RecipeCategoryTypes.Backend,
    importYaml: CONTRIBUTTE_IMPORT_YAML,
    listed: true,
    title: 'Contributte',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-nette-contributte' },
    ],
    desc: `<a href="https://github.com/contributte/webapp-skeleton" target="_blank">Nette Contributte</a> is a web application skeleton based on Nette Framework, Doctrine and Contributte libraries. <a href="https://zerops.io" target="_blank">Zerops</a> recipe for Contributte skeleton includes session and cache stored in Redis, and PostgreSQL DB with doctrine migrations.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Nette running on a load balanced <strong>Zerops PHP + Nginx</strong> service</li>
        <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
        <li>Zerops KeyDB (<strong>Redis</strong>) service for session and cache</li>
        <li>Proper setup for Nettrine <strong>cache</strong>, <strong>optimization</strong>, and <strong>database migrations</strong></li>
        <li>Logs set up to use <strong>syslog</strong> and accessible through Zerops GUI</li>
        <li>Utilization of Zerops built-in <strong>environment variables</strong> system</li>
        <li><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a> as <strong>SMTP mock server</strong></li>
        <li><a href="https://www.adminer.org/en/" target="_blank">Adminer</a> for <strong>quick database management</strong> tool</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>Base of the recipe is ready for production, the difference comes down to:</p>
      <ul>
        <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
        <li>Use at least two containers for Nette service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>app</em> service section)</li>
        <li>Use production-ready third-party SMTP server instead of Mailpit (change <em>parameters.smtp</em> variables in <em>./config/app/parameters.neon</em> file)</li>
        <li>Disable public access to Adminer or remove it altogether (remove service <em>adminer</em> from recipe YAML)</li>
        <li>Set <em>NETTE_DEBUG</em> to <em>0</em> and <em>NETTE_ENV</em> to <em>prod</em> in <em>envSecrets</em>, <em>app</em> section of import YAML</li>
        <li>Create <em>admin</em> user manually through <em>create-user</em> console command (in dev mode this is handled by fixtures) and
          <ul>
            <li>remove following line from <em>zerops.yml</em>:<br />
                <pre>- zsc execOnce \${appVersionId}-fixtures -- php /var/www/bin/console doctrine:fixtures:load --no-interaction</pre>
            </li>
            <li>add <em>--no-dev</em> to the following line in <em>zerops.yml</em>:
              <pre>composer install --optimize-autoloader</pre>
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Nette app to efficiently run on Zerops, these are the general steps we took:</p>
      <ul>
        <li>Add <a href="https://github.com/zeropsio/recipe-contributte/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository, our example includes idempotent migrations, caching, and optimized build process</li>
        <li>Add <pre>$configurator->addDynamicParameters(['env' => getenv()]);</pre> to your <a href="https://github.com/zeropsio/recipe-contributte/blob/main/app/Bootstrap.php:25" target="_blank">./app/Bootstrap.php</a> file to use env variables in your neon configuration files</li>
        <li>Add <a href="https://github.com/contributte/redis" target="_blank">contributte/redis</a> to your composer.json to store sessions in Redis
          <ul>
            <li>configure it according to our <a href="https://github.com/zeropsio/recipe-contributte/blob/main/config/env/base.neon#L55" target="_blank">./config/env/base.neon</a> file</li>
          </ul>
        </li>
        <li>Add <a href="https://github.com/contributte/monolog" target="_blank">contributte/monolog</a> to your composer.json to log into the syslog
          <ul>
            <li>utilize the following handler: <em>Monolog\\Handler\\SyslogHandler(app)</em> (see our <a href="https://github.com/MichalSalon/recipe-contributte/blob/main/config/ext/contributte.neon#L31" target="_blank">./config/ext/contributte.neon</a>)</li>
          </ul>
        </li>
      </ul>
    </section>

    <section>
      <h2>Additional info</h2>
      <p>Admin login for this recipe is <em>admin@admin.cz</em> with automatically generated password, which can be found under <em>ADMIN_PASSWORD</em> name in Zerops Environment variables section of <em>app</em> service.</p>
    </section>
    `,
  },
  // umami
  {
    id: 'umami',
    recipeId: 'zeropsio/recipe-umami',
    slug: 'umami',
    tag: 'Umami',
    logo: 'umami',
    icon: undefined,
    disabled: true,
    listed: true,
    category: RecipeCategoryTypes.ProjectUtility,
    importYaml: NESTJS_IMPORT_YAML,
    desc: `Nest.js app. Deployed from GitHub repository <a href="https://github.com/zeropsio/recipe-nestjs">zeropsio/recipe-nestjs</a>`,
  },
  // ghost
  {
    id: 'ghost',
    recipeId: 'zeropsio/recipe-ghost',
    slug: 'ghost',
    tag: 'Ghost',
    logo: 'ghost',
    icon: undefined,
    title: 'Ghost',
    listed: true,
    category: RecipeCategoryTypes.ProjectUtility,
    importYaml: GHOST_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-ghost' }],
    desc: `Ghost is an open source blogging platform that can be used as a headless CMS. This recipe showcases how to properly setup and run Ghost on Zerops.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Zerops <strong>MariaDB 10.6</strong> service as database</li>
        <li>Zerops <strong>Object Storage</strong> (S3 compatible) service as file system</li>
        <li>Logs set up to use <strong>syslog</strong> and accessible through Zerops GUI</li>
        <li>Utilization of Zerops built-in <strong>environment variables</strong> system</li>
        <li><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a> as <strong>SMTP mock server</strong></li>
      </ul>
    </section>

    <section>
      <h2>How to use installed recipe in Zerops GUI</h2>
      <ul>
        <li>Wait till the moment the recipe's services are installed and initialized.</li>
        <li>Open the auto-generated subdomain URL available for the <em>ghost</em> service.</li>
        <li>Switch to the admin client GUI through adding <em>/ghost</em> route to the subdomain URL.</li>
        <li>Fill out the form to register as an administrator of the new Ghost site.</li>
        <li>Open the auto-generated subdomain URL available for the <em>mailpit</em> service.</li>
        <li>Check a confirmation email sent from the Ghost service.</li>
        <li>Use installed and running Ghost CMS to publish articles.</li>
        <li>Register new subscribers to consume the Ghost site content.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development mode</h2>
      <p>The difference may come down to:</p>
      <ul>
        <li>Use the highly available version of the MariaDB database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section) in which case Galera cluster is created. Use SQL command <em>SET GLOBAL wsrep_sync_wait=1;</em> to globally set the synchronization among database nodes because of the actual state of Ghost's support for database HA. The best place where to do it is in the <em>run.initCommands</em> of the <a href="https://github.com/zeropsio/recipe-ghost/blob/main/zerops.yml" target="_blank">zerops.yml</a> file.</li>
        <li>Think about some caching mechanism (such as Zerops KeyDB service, CDN) instead of the database HA mode because of the static character of the Ghost pages.</li>
        <li>Use a production-ready third-party SMTP server instead of Mailpit.</li>
        <li><strong>WARNING</strong><br>Ghost does not support high availability (running on multiple container), make sure vertical autoscaling is fixed on 1 container (default in this recipe).</li>
      </ul>
     </section>
     `,
  },
  // payload
  {
    id: 'payload',
    recipeId: 'zeropsio/recipe-payload',
    slug: 'payload',
    tag: 'Payload',
    logo: 'payload',
    icon: undefined,
    title: 'Payload',
    listed: true,
    category: RecipeCategoryTypes.ProjectUtility,
    importYaml: PAYLOAD_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-payload' }],
    desc: `<a href="https://github.com/payloadcms/payload" target="_blank">Payload CMS</a> is fully open source and can be used both as an app framework and a headless CMS. This recipe showcases how to set up and run Payload on Zerops properly. It was created using the <a href="https://www.npmjs.com/package/create-payload-app" target="_blank">create-payload-app CLI</a>, based on Payload version v3.28.1 and its <a href="https://github.com/payloadcms/payload/tree/main/templates/website" target="_blank">website</a> template.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Zerops <strong>PostgreSQL</strong> 16.2 service as database</li>
        <li>Zerops <strong>Object Storage</strong> (S3 compatible) service as file system using a private bucket</li>
        <li>Logs set up to use <strong>syslog</strong> and accessible through Zerops GUI</li>
        <li>Utilization of Zerops built-in <strong>environment variables</strong> system</li>
        <li><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a> as <strong>SMTP mock server</strong></li>
      </ul>
    </section>

    <section>
      <h2>How to use installed recipe in Zerops GUI</h2>
      <ul>
        <li>Wait till the moment the recipe's services are installed and initialized.</li>
        <li>Open the auto-generated subdomain URL available for the <strong>api</strong> service.</li>
        <li><strong>Visit the admin dashboard</strong> through the offered link on the shown page.</li>
        <li>Register the first administration user and log in to the admin client.</li>
        <li>Click the <strong>Seed your database</strong> link to fill out some content.</li>
        <li>Using the admin dashboard, you can publish your custom content.</li>
        <li>Open the auto-generated subdomain URL available for the <strong>mailpit</strong> service.</li>
        <li>The <strong>Mailpit</strong> SMTP mock server will receive any email sent by the Payload API.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development mode</h2>
      <p>The difference may come down to:</p>
      <ul>
        <li>Use the highly available version of the PostgreSQL database (change <strong>mode</strong> from <strong>NON_HA</strong> to <strong>HA</strong> in recipe YAML, <strong>db</strong> service section) in which case <a href="https://patroni.readthedocs.io">Patroni cluster</a> is created.</li>
        <li>Think about some caching mechanism (such as Zerops KeyDB or Valkey service, CDN) instead of the database HA mode because of the static character of the Payload pages.</li>
        <li>Try running Payload CMS on multiple runtime containers in high availability (change <strong>maxContainers</strong> from <strong>1</strong> to <strong>2</strong> or more in recipe YAML, <strong>api</strong> service section).</li>
        <li>Use a production-ready third-party SMTP server instead of Mailpit.</li>
      </ul>
     </section>
     `,
  },
  // medusa
  {
    id: 'medusa-analog-dev',
    recipeId: 'zeropsio/recipe-medusa-analog-dev',
    slug: 'medusa-analog-dev',
    tag: 'Medusa',
    logo: 'medusa',
    icon: 'medusa',
    title: 'Medusa.js x Analog.js x spartan.ng development environment',
    listed: false,
    category: RecipeCategoryTypes.ProjectUtility,
    importYaml: MEDUSA_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-medusa' }],
    desc: `Medusa.js is a powerfull and flexible commerce platform, Zerops provides the infrastructure needed to utilize Medusa to its fullest.`,
    content: ``
  },
  // medusa next prod
  {
    id: 'medusa-next-prod',
    recipeId: 'zeropsio/recipe-medusa-next-prod',
    slug: 'medusa-next-prod',
    tag: 'Medusa',
    logo: 'medusa',
    icon: 'medusa',
    title: 'Medusa.js x Next.js production environment',
    listed: false,
    category: RecipeCategoryTypes.ProjectUtility,
    importYaml: MEDUSA_NEXT_PROD_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-medusa' }],
    desc: `Medusa.js is a powerfull and flexible commerce platform, Zerops provides the infrastructure needed to utilize Medusa to its fullest.`,
    content: ``
  },
  // medusa next dev
  {
    id: 'medusa-next-dev',
    recipeId: 'zeropsio/recipe-medusa-next-dev',
    slug: 'medusa-next-dev',
    tag: 'Medusa',
    logo: 'medusa',
    icon: 'medusa',
    title: 'Medusa.js x Next.js development environment',
    listed: false,
    category: RecipeCategoryTypes.ProjectUtility,
    importYaml: MEDUSA_NEXT_DEV_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-medusa' }],
    desc: `Medusa.js is a powerfull and flexible commerce platform, Zerops provides the infrastructure needed to utilize Medusa to its fullest.`,
    content: ``
  },
  // qwik
  {
    id: 'qwik',
    recipeId: 'zeropsio/recipe-qwik',
    slug: 'qwik',
    tag: 'Qwik',
    logo: 'qwik',
    icon: undefined,
    title: 'Qwik SSR + Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: QWIK_IMPORT_YAML,
    repository: [
      {
        name: 'SSR',
        repository: 'https://github.com/zeropsio/recipe-qwik-nodejs',
      },
      {
        name: 'Static',
        repository: 'https://github.com/zeropsio/recipe-qwik-static',
      },
    ],
    desc: `<a target="_blank" href="https://qwik.dev/">Qwik</a> is a web framework for building instead loading web applications at any size or complexity. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Qwik apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Qwik</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
        <li>Latest version of <strong>Qwik</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default SSR installation</h2>
      <p>If you want to modify your existing Qwik app to efficiently run on Zerops, follow these steps:</p>
      <ol>
        <li>Install the necessary adapter with:
          <pre>npm run qwik add express</pre>
          <p>Running this command will make the following changes:</p>
          <ul>
            <li>A <em>build.server</em> & <em>serve</em> script will be automatically added to your <em>package.json</em> file.</li>
            <li>A <em>adapters/express/vite.config.ts</em> and <em>src/entry.express.tsx</em> will be created.</li>
            <li>It will install the required dependencies for SSR.</li>
          </ul>
        </li>
        <li>Now, just add the <a href="https://github.com/zeropsio/recipe-qwik-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
      </ol>
    </section>
    <section>
      <h2>Changes made over the default SSG installation</h2>
      <p>If you want to modify your existing Qwik app to efficiently run on Zerops, follow these steps:</p>
      <ol>
        <li>Install the necessary adapter with:
          <pre>npm run qwik add static</pre>
          <p>Running this command will make the following changes:</p>
          <ul>
            <li>A <em>build.server</em> script will be automatically added to your <em>package.json</em> file.</li>
            <li>A <em>adapters/static/vite.config.ts</em> file will be created.</li>
          </ul>
        </li>
        <li>Now, just add the <a href="https://github.com/zeropsio/recipe-qwik-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
      </ol>
    </section>
    `
  },
  // qwik-nodejs
  {
    id: 'qwik-nodejs',
    recipeId: 'zeropsio/recipe-qwik-nodejs',
    slug: 'qwik-nodejs',
    tag: 'Qwik',
    logo: 'qwik',
    icon: undefined,
    title: 'Qwik SSR',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: QWIK_NODEJS_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-qwik-nodejs' },
    ],
    desc: `<a target="_blank" href="https://qwik.dev/">Qwik</a> is a web framework for building instead loading web applications at any size or complexity. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Qwik apps, both server side rendered and static, a breeze. This recipe showcases the SSR version.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Qwik</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Qwik app to efficiently run on Zerops, follow these steps:</p>
      <ol>
        <li>Install the necessary adapter with:
          <pre>npm run qwik add express</pre>
          <p>Running this command will make the following changes:</p>
          <ul>
            <li>A <em>build.server</em> & <em>serve</em> script will be automatically added to your <em>package.json</em> file.</li>
            <li>A <em>adapters/express/vite.config.ts</em> and <em>src/entry.express.tsx</em> will be created.</li>
            <li>It will install the required dependencies for SSR.</li>
          </ul>
        </li>
        <li>Now, just add the <a href="https://github.com/zeropsio/recipe-qwik-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
      </ol>
    </section>
    `,
  },
  // qwik-static
  {
    id: 'qwik-static',
    recipeId: 'zeropsio/recipe-qwik-static',
    slug: 'qwik-static',
    tag: 'Qwik',
    logo: 'qwik',
    icon: undefined,
    title: 'Qwik static',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: QWIK_STATIC_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-qwik-static' },
    ],
    desc: `<a target="_blank" href="https://qwik.dev/">Qwik</a> is a web framework for building instead loading web applications at any size or complexity. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Qwik apps, both server side rendered and static, a breeze. This recipe showcases the static version.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Qwik</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Qwik app to efficiently run on Zerops, follow these steps:</p>
      <ol>
        <li>Install the necessary adapter with:
          <pre>npm run qwik add static</pre>
          <p>Running this command will make the following changes:</p>
          <ul>
            <li>A <em>build.server</em> script will be automatically added to your <em>package.json</em> file.</li>
            <li>A <em>adapters/static/vite.config.ts</em> file will be created.</li>
          </ul>
        </li>
      </ol>
      <p>Now, just add the <a href="https://github.com/zeropsio/recipe-qwik-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</p>
    </section>
    `,
  },
  // analog
  {
    id: 'analog',
    recipeId: 'zeropsio/recipe-analog',
    slug: 'analog',
    tag: 'Analog',
    logo: 'analog',
    icon: undefined,
    title: 'Analog SSR + Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: ANALOG_IMPORT_YAML,
    repository: [
      {
        name: 'SSR',
        repository: 'https://github.com/zeropsio/recipe-analog-nodejs',
      },
      {
        name: 'Static',
        repository: 'https://github.com/zeropsio/recipe-analog-static',
      },
    ],
    desc: `<a target="_blank" href="https://analogjs.org">Analog</a> is a fullstack meta-framework for building applications and websites with Angular. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Analog apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Analog</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
        <li>Latest version of <strong>Analog</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default SSG installation</h2>
      <p>If you want to modify your existing Analog app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-analog-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
      </ol>

    </section>
    <section>
      <h2>Changes made over the default SSR installation</h2>
      <p>If you want to modify your existing Analog app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-analog-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
    </section>`,
  },
  // analog-nodejs
  {
    id: 'analog-nodejs',
    recipeId: 'zeropsio/recipe-analog-nodejs',
    slug: 'analog-nodejs',
    tag: 'Analog',
    logo: 'analog',
    icon: undefined,
    title: 'Analog SSR',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: ANALOG_NODEJS_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-analog-nodejs' },
    ],
    desc: `<a target="_blank" href="https://analogjs.org">Analog</a> is a fullstack meta-framework for building applications and websites with Angular. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Analog apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Analog</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Analog app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-analog-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
    </section>
    `,
  },
  // analog-static
  {
    id: 'analog-static',
    recipeId: 'zeropsio/recipe-analog-static',
    slug: 'analog-static',
    tag: 'Analog',
    logo: 'analog',
    icon: undefined,
    title: 'Analog Static',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: ANALOG_STATIC_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-analog-static' },
    ],
    desc: `<a target="_blank" href="https://analogjs.org">Analog</a> is a fullstack meta-framework for building applications and websites with Angular. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Analog apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Analog</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Analog app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-analog-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
    </section>
    `,
  },
  // nuxt
  {
    id: 'nuxt',
    recipeId: 'zeropsio/recipe-nuxt',
    slug: 'nuxt',
    tag: 'Nuxt',
    logo: 'nuxtjs',
    icon: undefined,
    title: 'Nuxt SSR + Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: NUXT_IMPORT_YAML,
    repository: [
      {
        name: 'SSR',
        repository: 'https://github.com/zeropsio/recipe-nuxt-nodejs',
      },
      {
        name: 'Static',
        repository: 'https://github.com/zeropsio/recipe-nuxt-static',
      },
    ],
    desc: `<a target="_blank" href="https://nuxt.com">Nuxt</a> is an open source Vue framework for building web applications intuitive and powerful. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Nuxt apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Nuxt</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
        <li>Latest version of <strong>Nuxt</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default SSG installation</h2>
      <p>If you want to modify your existing Nuxt app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-nuxt-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
      </ol>

    </section>
    <section>
      <h2>Changes made over the default SSR installation</h2>
      <p>If you want to modify your existing Nuxt app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-nuxt-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
    </section>`,
  },
  // nuxt-nodejs
  {
    id: 'nuxt-nodejs',
    recipeId: 'zeropsio/recipe-nuxt-nodejs',
    slug: 'nuxt-nodejs',
    tag: 'Nuxt',
    logo: 'nuxtjs',
    icon: undefined,
    title: 'Nuxt SSR',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: NUXT_NODEJS_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-nuxt-nodejs' },
    ],
    desc: `<a target="_blank" href="https://nuxt.com">Nuxt</a> is an open source Vue framework for building web applications intuitive and powerful. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Nuxt apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Nuxt</strong> with SSR running on a <strong>Zerops Node.js</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Nuxt app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-nuxt-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
    </section>
    `,
  },
  // nuxt-static
  {
    id: 'nuxt-static',
    recipeId: 'zeropsio/recipe-nuxt-static',
    slug: 'nuxt-static',
    tag: 'Nuxt',
    logo: 'nuxtjs',
    icon: undefined,
    title: 'Nuxt Static',
    listed: false,
    category: RecipeCategoryTypes.Frontend,
    importYaml: NUXT_STATIC_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-nuxt-static' },
    ],
    desc: `<a target="_blank" href="https://nuxt.com">Nuxt</a> is an open source Vue framework for building web applications intuitive and powerful. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Nuxt apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Nuxt</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Nuxt app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-nuxt-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
    </section>
    `,
  },
  // discord-nodejs
  // {
  //   id: 'discord-nodejs',
  //   recipeId: 'zeropsio/recipe-discord-nodejs',
  //   slug: 'discord-nodejs',
  //   tag: 'Discord Node.js',
  //   logo: 'discord',
  //   icon: undefined,
  //   title: 'Discord Node.js',
  //   listed: true,
  //   category: RecipeCategory.PlatformBots,
  //   importYaml: DISCORD_NODEJS_IMPORT_YAML,
  //   repository: [
  //     { repository: 'https://github.com/zeropsio/recipe-discord-nodejs' },
  //   ],
  //   desc: `This Example uses <a target="_blank" href="https://discord.js.org/">Discord.js</a> - a powerful module that allows you to interact with the Discord API very easily. This is the most bare-bones example of Discord.js bot running on Zerops Bun Runtime with a single /ping command.`,
  //   content: `
  //   <section>
  //     <h2>Recipe features</h2>
  //     <ul>
  //       <li>Latest version of <strong>Discord.js</strong> running on a <strong>Zerops Node.js</strong> service.</li>
  //     </ul>
  //   </section>
  //   <section>
  //     <h2>Setting up Environment Variables</h2>
  //     <p>The steps mentioned here are to be followed after deploying the app and will guide you on how to obtain the two required environment variables to run your Discord.js Bot.</p>
  //     <ol>
  //       <li>Go to the <a href="https://discord.com/developers/applications" target="_blank">Discord Application Portal</a>. Create an application if you do not have one already</li>
  //       <ul>
  //         <li>Copy the application ID from the General Information section (sidebar). This will be used for <em>DISCORD_CLIENT_ID</em>.</li>
  //         <li>Go to the Bot section (sidebar), reset the token, and copy the token. This will be used for <em>DISCORD_TOKEN</em>.</li>
  //       </ul>
  //     <p>Now you have both environment variables.</p>
  //       <li>Head to your service. If you have full mode, check your sidebar and click on Environment Variables. On that page, you will see an "edit multiple secret variables in .env format" button. Click on it, paste your environment variables in the format shown below, and click on Update Secret Variables. You will then see a button to commit your changes.</li>
  //         <p>Note: These Environment Variables are already invalidated.</p>
  //         <pre>DISCORD_TOKEN=bot-token</pre>
  //         <pre>DISCORD_CLIENT_ID=bot-client-id</pre>
  //     </ol>
  //   <section>
  // {
  //   id: 'discord-nodejs',
  //   recipeId: 'zeropsio/recipe-discord-nodejs',
  //   slug: 'discord-nodejs',
  //   tag: 'Discord Node.js',
  //   logo: 'discord',
  //   icon: undefined,
  //   title: 'Discord Node.js',
  //   listed: true,
  //   category: RecipeCategoryTypes.PlatformBots,
  //   importYaml: DISCORD_NODEJS_IMPORT_YAML,
  //   repository: [
  //     { repository: 'https://github.com/zeropsio/recipe-discord-nodejs' },
  //   ],
  //   desc: `This Example uses <a target="_blank" href="https://discord.js.org/">Discord.js</a> - a powerful module that allows you to interact with the Discord API very easily. This is the most bare-bones example of Discord.js bot running on Zerops Bun Runtime with a single /ping command.`,
  //   content: `
  //   <section>
  //     <h2>Recipe features</h2>
  //     <ul>
  //       <li>Latest version of <strong>Discord.js</strong> running on a <strong>Zerops Node.js</strong> service.</li>
  //     </ul>
  //   </section>
  //   <section>
  //     <h2>Setting up Environment Variables</h2>
  //     <p>The steps mentioned here are to be followed after deploying the app and will guide you on how to obtain the two required environment variables to run your Discord.js Bot.</p>
  //     <ol>
  //       <li>Go to the <a href="https://discord.com/developers/applications" target="_blank">Discord Application Portal</a>. Create an application if you do not have one already</li>
  //       <ul>
  //         <li>Copy the application ID from the General Information section (sidebar). This will be used for <em>DISCORD_CLIENT_ID</em>.</li>
  //         <li>Go to the Bot section (sidebar), reset the token, and copy the token. This will be used for <em>DISCORD_TOKEN</em>.</li>
  //       </ul>
  //     <p>Now you have both environment variables.</p>
  //       <li>Head to your service. If you have full mode, check your sidebar and click on Environment Variables. On that page, you will see an "edit multiple secret variables in .env format" button. Click on it, paste your environment variables in the format shown below, and click on Update Secret Variables. You will then see a button to commit your changes.</li>
  //         <p>Note: These Environment Variables are already invalidated.</p>
  //         <pre>DISCORD_TOKEN=bot-token</pre>
  //         <pre>DISCORD_CLIENT_ID=bot-client-id</pre>
  //     </ol>
  //   <section>

  // //   </section>
  // //   <section>
  // //     <h2>Production vs. development</h2>
  // //     <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
  // //   </section>

  // //   <section>
  // //     <h2>Changes made over the default installation</h2>
  // //     <p>If you want to modify your existing Discord.js bot to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-discord-nodejs/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository and setup environment variables.</p>
  // //   </section>`,
  // },
  // discord-bun
  // {
  //   id: 'discord-bun',
  //   recipeId: 'zeropsio/recipe-discord-bun',
  //   slug: 'discord-bun',
  //   tag: 'Discord Bun',
  //   logo: 'discord',
  //   icon: undefined,
  //   title: 'Discord Bun',
  //   listed: true,
  //   category: RecipeCategory.PlatformBots,
  //   importYaml: DISCORD_BUN_IMPORT_YAML,
  //   repository: [
  //     { repository: 'https://github.com/zeropsio/recipe-discord-bun' },
  //   ],
  //   desc: `This Example uses <a target="_blank" href="https://discord.js.org/">Discord.js</a> - a powerful module that allows you to interact with the Discord API very easily. This is the most bare-bones example of Discord.js bot running on Zerops Bun Runtime with a single /ping command.`,
  //   content: `
  //   <section>
  //     <h2>Recipe features</h2>
  //     <ul>
  //       <li>Latest version of <strong>Discord.js</strong> running on a <strong>Zerops Bun</strong> service.</li>
  //     </ul>
  //   </section>
  //   <section>
  //     <h2>Setting up Environment Variables</h2>
  //     <p>The steps mentioned here are to be followed after deploying the app and will guide you on how to obtain the two required environment variables to run your Discord.js Bot.</p>
  //     <ol>
  //       <li>Go to the <a href="https://discord.com/developers/applications" target="_blank">Discord Application Portal</a>. Create an application if you do not have one already</li>
  //       <ul>
  //         <li>Copy the application ID from the General Information section (sidebar). This will be used for <em>DISCORD_CLIENT_ID</em>.</li>
  //         <li>Go to the Bot section (sidebar), reset the token, and copy the token. This will be used for <em>DISCORD_TOKEN</em>.</li>
  //       </ul>
  //     <p>Now you have both environment variables.</p>
  //       <li>Head to your service. If you have full mode, check your sidebar and click on Environment Variables. On that page, you will see an "edit multiple secret variables in .env format" button. Click on it, paste your environment variables in the format shown below, and click on Update Secret Variables. You will then see a button to commit your changes.</li>
  //         <p>Note: These Environment Variables are already invalidated.</p>
  //         <pre>DISCORD_TOKEN=bot-token</pre>
  //         <pre>DISCORD_CLIENT_ID=bot-client-id</pre>
  //     </ol>
  //   <section>
  // {
  //   id: 'discord-bun',
  //   recipeId: 'zeropsio/recipe-discord-bun',
  //   slug: 'discord-bun',
  //   tag: 'Discord Bun',
  //   logo: 'discord',
  //   icon: undefined,
  //   title: 'Discord Bun',
  //   listed: true,
  //   category: RecipeCategoryTypes.PlatformBots,
  //   importYaml: DISCORD_BUN_IMPORT_YAML,
  //   repository: [
  //     { repository: 'https://github.com/zeropsio/recipe-discord-bun' },
  //   ],
  //   desc: `This Example uses <a target="_blank" href="https://discord.js.org/">Discord.js</a> - a powerful module that allows you to interact with the Discord API very easily. This is the most bare-bones example of Discord.js bot running on Zerops Bun Runtime with a single /ping command.`,
  //   content: `
  //   <section>
  //     <h2>Recipe features</h2>
  //     <ul>
  //       <li>Latest version of <strong>Discord.js</strong> running on a <strong>Zerops Bun</strong> service.</li>
  //     </ul>
  //   </section>
  //   <section>
  //     <h2>Setting up Environment Variables</h2>
  //     <p>The steps mentioned here are to be followed after deploying the app and will guide you on how to obtain the two required environment variables to run your Discord.js Bot.</p>
  //     <ol>
  //       <li>Go to the <a href="https://discord.com/developers/applications" target="_blank">Discord Application Portal</a>. Create an application if you do not have one already</li>
  //       <ul>
  //         <li>Copy the application ID from the General Information section (sidebar). This will be used for <em>DISCORD_CLIENT_ID</em>.</li>
  //         <li>Go to the Bot section (sidebar), reset the token, and copy the token. This will be used for <em>DISCORD_TOKEN</em>.</li>
  //       </ul>
  //     <p>Now you have both environment variables.</p>
  //       <li>Head to your service. If you have full mode, check your sidebar and click on Environment Variables. On that page, you will see an "edit multiple secret variables in .env format" button. Click on it, paste your environment variables in the format shown below, and click on Update Secret Variables. You will then see a button to commit your changes.</li>
  //         <p>Note: These Environment Variables are already invalidated.</p>
  //         <pre>DISCORD_TOKEN=bot-token</pre>
  //         <pre>DISCORD_CLIENT_ID=bot-client-id</pre>
  //     </ol>
  //   <section>

  // //   </section>
  // //   <section>
  // //     <h2>Production vs. development</h2>
  // //     <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
  // //   </section>

  // //   <section>
  // //     <h2>Changes made over the default installation</h2>
  // //     <p>If you want to modify your existing Discord.js bot to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-discord-bun/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository and setup environment variables.</p>
  // //   </section>`,
  // },
  // discord-py
  // {
  //   id: 'discord-py',
  //   recipeId: 'zeropsio/recipe-discord-py',
  //   slug: 'discord-py',
  //   tag: 'Discord Python',
  //   logo: 'discord',
  //   icon: undefined,
  //   title: 'Discord Python',
  //   listed: true,
  //   category: RecipeCategory.PlatformBots,
  //   importYaml: DISCORD_PY_IMPORT_YAML,
  //   repository: [
  //     { repository: 'https://github.com/zeropsio/recipe-discord-py' },
  //   ],
  //   desc: `This Example uses <a target="_blank" href="https://discord.js.org/">Discord.py</a> - a powerful module that allows you to interact with the Discord API very easily. This is the most bare-bones example of Discord.py bot running on Zerops Python Runtime with a single /ping command.`,
  //   content: `
  //   <section>
  //     <h2>Recipe features</h2>
  //     <ul>
  //       <li>Latest version of <strong>Discord.py</strong> running on a <strong>Zerops Python</strong> service.</li>
  //     </ul>
  //   </section>
  //   <section>
  //     <h2>Setting up Environment Variables</h2>
  //     <p>The steps mentioned here are to be followed after deploying the app and will guide you on how to obtain the two required environment variables to run your Discord.js Bot.</p>
  //     <ol>
  //       <li>Go to the <a href="https://discord.com/developers/applications" target="_blank">Discord Application Portal</a>. Create an application if you do not have one already.</li>
  //       <ul>
  //         <li>Go to the Bot section (sidebar), reset the token, and copy the token. This will be used for <em>DISCORD_TOKEN</em>.</li>
  //       </ul>
  //     <p>Now you have both environment variables.</p>
  //       <li>Head to your service. If you have full mode, check your sidebar and click on Environment Variables. On that page, you will see an "edit multiple secret variables in .env format" button. Click on it, paste your environment variables in the format shown below, and click on Update Secret Variables. You will then see a button to commit your changes.</li>
  //         <p>Note: These Environment Variables are already invalidated.</p>
  //         <pre>DISCORD_TOKEN=bot-token</pre>
  //     </ol>
  //   <section>
  // {
  //   id: 'discord-py',
  //   recipeId: 'zeropsio/recipe-discord-py',
  //   slug: 'discord-py',
  //   tag: 'Discord Python',
  //   logo: 'discord',
  //   icon: undefined,
  //   title: 'Discord Python',
  //   listed: true,
  //   category: RecipeCategoryTypes.PlatformBots,
  //   importYaml: DISCORD_PY_IMPORT_YAML,
  //   repository: [
  //     { repository: 'https://github.com/zeropsio/recipe-discord-py' },
  //   ],
  //   desc: `This Example uses <a target="_blank" href="https://discord.js.org/">Discord.py</a> - a powerful module that allows you to interact with the Discord API very easily. This is the most bare-bones example of Discord.py bot running on Zerops Python Runtime with a single /ping command.`,
  //   content: `
  //   <section>
  //     <h2>Recipe features</h2>
  //     <ul>
  //       <li>Latest version of <strong>Discord.py</strong> running on a <strong>Zerops Python</strong> service.</li>
  //     </ul>
  //   </section>
  //   <section>
  //     <h2>Setting up Environment Variables</h2>
  //     <p>The steps mentioned here are to be followed after deploying the app and will guide you on how to obtain the two required environment variables to run your Discord.js Bot.</p>
  //     <ol>
  //       <li>Go to the <a href="https://discord.com/developers/applications" target="_blank">Discord Application Portal</a>. Create an application if you do not have one already.</li>
  //       <ul>
  //         <li>Go to the Bot section (sidebar), reset the token, and copy the token. This will be used for <em>DISCORD_TOKEN</em>.</li>
  //       </ul>
  //     <p>Now you have both environment variables.</p>
  //       <li>Head to your service. If you have full mode, check your sidebar and click on Environment Variables. On that page, you will see an "edit multiple secret variables in .env format" button. Click on it, paste your environment variables in the format shown below, and click on Update Secret Variables. You will then see a button to commit your changes.</li>
  //         <p>Note: These Environment Variables are already invalidated.</p>
  //         <pre>DISCORD_TOKEN=bot-token</pre>
  //     </ol>
  //   <section>

  // //   </section>
  // //   <section>
  // //     <h2>Production vs. development</h2>
  // //     <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
  // //   </section>

  // //   <section>
  // //     <h2>Changes made over the default installation</h2>
  // //     <p>If you want to modify your existing Discord.js bot to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-discord-py/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository and setup environment variables.</p>
  // //   </section>`,
  // },
  // spring
  {
    id: 'spring',
    recipeId: 'zeropsio/recipe-spring',
    slug: 'spring',
    tag: 'Spring',
    logo: 'spring',
    icon: undefined,
    title: 'Spring',
    listed: true,
    category: RecipeCategoryTypes.Backend,
    importYaml: SPRING_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-spring' }],
    desc: `<a href="https://spring.io/">Spring</a> is world's most popular Java framework designed for building enterprise-level Java applications. This recipe aims to showcase basic Spring concepts and how to integrate them with <a href="https://zerops.io">Zerops</a>, all through a simple file upload demo application.`,
    content: `
      <section>
        <h2>Recipe features</h2>
        <ul>
          <li><strong>Load balanced</strong> Spring web app running on <strong>Zerops Java</strong> service</li>
          <li>Served by production-ready embedded application server <strong><a href="https://spring.io/">Tomcat</a></strong></li>
          <li>Zerops <strong>PostgreSQL 16</strong> service as database</li>
          <li>Zerops <strong>Object Storage</strong> (S3 compatible) service as file system</li>
          <li>Automatic on-startup Spring <strong>database migrations</strong></li>
          <li>Utilization of Zerops built-in <strong>environment variables</strong> system</li>
          <li>Logs accessible through Zerops GUI</li>
          <li><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a> as <strong>SMTP mock server</strong></li>
          <li><a href="https://www.adminer.org" target="_blank">Adminer</a> for <strong>quick database management</strong> tool</li>
          <li>Unlocked development experience:
            <ul>
              <li>Access to database and mail mock through Zerops project VPN (<em>zcli vpn up</em>)</li>
              <li>Prepared <em>.env.dist</em> file (<em>cp .env.dist .env</em> and change ***** secrets found in Zerops GUI)</li>
            </ul>
          </li>
        </ul>
      </section>

      <section>
        <h2>Production vs. development</h2>
        <p>Base of the recipe is ready for production, the difference comes down to:</p>
        <ul>
          <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
          <li>Use at least two containers for Spring service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>api</em> service section)</li>
          <li>Use production-ready third-party SMTP server instead of Mailpit (change <em>MAIL_</em> secret variables in recipe YAML <em>api</em> service)</li>
          <li>Disable public access to Adminer or remove it altogether (remove service <em>adminer</em> from recipe YAML)</li>
        </ul>
      </section>

      <section>
        <h2>Changes made over the default installation</h2>
        <p>If you want to modify your existing Spring app to efficiently run on Zerops, these are the general steps we took:</p>
        <ul>
          <li>Add <a href="https://github.com/zeropsio/recipe-spring/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository, our example includes migrations and build process</li>
        </ul>
      </section>
    `,
  },
  // symfony
  {
    id: 'symfony',
    recipeId: 'zeropsio/recipe-symfony',
    slug: 'symfony',
    tag: 'Symfony',
    logo: 'symfony',
    icon: undefined,
    title: 'Symfony',
    listed: true,
    category: RecipeCategoryTypes.Backend,
    importYaml: SYMFONY_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-symfony' }],
    desc: `<a href="https://symfony.com/">Symfony</a> is one of the leading PHP frameworks for building web applications. This recipe helps you to get started with a Symfony Demo app on the Zerops platform.`,
    content: `
      <section>
        <h2>Recipe features</h2>
        <ul>
          <li>Symfony running on a load balanced <strong>Zerops PHP + Nginx</strong> service.</li>
          <li>Zerops <strong>PostgresSQL 16</strong> service as a database.</li>
          <li>Zerops KeyDB (<strong>Redis</strong>) service for session storage.</li>
          <li>Setup for Doctrine <strong>database migrations</strong>.</li>
          <li>Logs set up to use <strong>syslog</strong> and accessible through Zerops GUI.</li>
          <li>Utilization of Zerops built-in <strong>environment variables</strong> system.</li>
          <li><a href="https://github.com/axllent/mailpit" target="_blank">Mailpit</a> as <strong>SMTP mock server</strong>.</li>
          <li><a href="https://www.adminer.org/en/" target="_blank">Adminer</a> for <strong>quick database management</strong>.</li>
        </ul>
      </section>

      <section>
        <h2>Production vs. development</h2>
        <p>Base of the recipe is ready for production, the difference comes down to:</p>
        <ul>
          <li>Use highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML, <em>db</em> service section)</li>
          <li>Use at least two containers for Symfony service to achieve high reliability and resilience (add <em>minContainers: 2</em> in recipe YAML, <em>app</em> service section)</li>
          <li>Use production-ready third-party SMTP server instead of Mailpit (change <em>MAILER_DSN</em> env variable in <em>./zerops.yml</em> file)</li>
          <li>Disable public access to Adminer or remove it altogether (remove service <em>adminer</em> from recipe YAML)</li>
        </ul>
      </section>

      <section>
        <h2>Changes made over the default installation</h2>
        <p>If you want to modify your existing Symfony app to efficiently run on Zerops, these are the general steps we took:</p>
        <ul>
          <li>Add <a href="https://github.com/zeropsio/recipe-symfony/blob/main/zerops.yml" target="_blank">zerops.yml</a> to your repository, our example includes idempotent migrations, caching, and optimized build process</li>
          <li>Set up <em>monolog.syslog_handler</em> to see logs in Zerops (see our <a href="https://github.com/zeropsio/recipe-symfony/blob/main/config/packages/monolog.yaml#L63" target="_blank">./config/packages/monolog.yaml</a>).</li>
          <li>Set up <em>session.handler_id</em> to store sessions inside Redis (see our <a href="https://github.com/zeropsio/recipe-symfony/blob/main/config/packages/framework.yaml#L16" target="_blank">./config/packages/framework.yaml</a>, we specifically use DB with index <em>0</em>).</li>
          <li>We had to move <em>twbs/bootstrap</em> from <em>require-dev</em> to <em>require</em> in the composer section for <em>composer install --no-dev</em> to work.</li>
          <li>We also had to update <em>symfonycasts/sass-bundle</em> to <em>v0.5</em> or newer for SASS compilation to work on Alpine Linux.</li>
        </ul>
      </section>
    `,
  },
  // angular-static
  {
    id: 'angular-static',
    recipeId: 'zeropsio/recipe-angular-static',
    slug: 'angular-static',
    tag: 'Angular',
    logo: 'angular',
    icon: undefined,
    title: 'Angular Static',
    listed: true,
    category: RecipeCategoryTypes.Frontend,
    importYaml: ANGULAR_STATIC_IMPORT_YAML,
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-angular-static' },
    ],
    desc: `<a target="_blank" href="https://angular.dev">Angular</a> is a web development for building modern applications. <a href="https://zerops.io" target="_blank">Zerops</a> makes deploying and running Angular apps, both server side rendered and static, a breeze.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li>Latest version of <strong>Angular</strong> with SSG running on a <strong>Zerops Static</strong> service.</li>
      </ul>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>This recipe is ready for production as is, and will scale horizontally by adding more containers in case of high traffic surges. If you want to achieve the highest baseline reliability and resilience, start with at least two containers (add <em>minContainers: 2</em> in recipe YAML in the <em>app</em> service section, or change the minimum containers in "Automatic Scaling configuration" section of service detail).</p>
    </section>

    <section>
      <h2>Changes made over the default installation</h2>
      <p>If you want to modify your existing Angular app to efficiently run on Zerops, there are no changes needed in the codebase on top of the standard installation, just add <a href="https://github.com/zeropsio/recipe-angular-static/blob/main/zerops.yml" target="_blank">zerops.yml</a> file to the root of your project, and make sure to check <em>package.json</em> for the scripts.</li>
    </section>
    `,
  },
  // phoenix
  {
    id: 'phoenix',
    recipeId: 'zeropsio/recipe-phoenix',
    slug: 'phoenix',
    tag: 'Phoenix',
    logo: 'phoenix',
    icon: undefined,
    title: 'Phoenix',
    listed: true,
    category: RecipeCategoryTypes.Backend,
    importYaml: PHOENIX_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-phoenix' }],
    desc: `<a href="https://www.phoenixframework.org/">Phoenix</a> is a web framework for building building fast, reliable web applications in Elixir. This recipe helps you to get started with a Phoenix app on the Zerops platform.`,
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Phoenix 1.7</strong> with <strong>LiveView</strong> for real-time features</li>
        <li><strong>PostgreSQL</strong> database integration with <strong>Ecto</strong></li>
        <li>Built with <strong>Bandit</strong> HTTP server (referenced in config/config.exs)</li>
        <li>Asset bundling with <strong>esbuild</strong> and <strong>Tailwind</strong></li>
        <li>Email support via <strong>Swoosh</strong></li>
        <li>Health check endpoint at <em>/status</em></li>
        <li>JSON handling with <strong>Jason</strong></li>
      </ul>
    </section>
    <section>
      <h2>Production vs. Development</h2>
      <p>Base of the recipe is ready for production. For production deployment, consider:</p>
      <ul>
        <li>Using highly available version of the PostgreSQL database (change <em>mode</em> from <em>NON_HA</em> to <em>HA</em> in recipe YAML)</li>
        <li>Using at least two containers for the Phoenix service (add <em>minContainers: 2</em> in recipe YAML)</li>
      </ul>
      <p>Further things to think about when running more complex, highly available Phoenix production apps on Zerops:</p>
      <ul>
        <li>Containers are volatile - use Zerops object storage to store your files</li>
        <li>Implement Redis (Valkey) for caching and session management</li>
      </ul>
    </section>`,
  },
  // laravel-minimal-local
  {
    id: 'laravel-minimal-local',
    recipeId: 'zeropsio/recipe-laravel-minimal-local',
    importYaml: LARAVEL_MINIMAL_LOCAL_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'laravel-minimal-local',
    logo: 'laravel',
    title: 'Basic Laravel —&nbsp;local&nbsp;environment',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-laravel-minimal' }
    ],
    desc: `
      This recipe showcases a production-ready integration of basic Laravel apps to Zerops. The fact this environment
      is for <strong>local development</strong> comes just from its minimal, cost-efficient resource allocation, selection of the
      <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Lightweight</a>
      core package and the fact you'd only start the services when you are actively working on the project.
      If you want to try the "production" environment setup with HA services and enterprise grade reliability deploy —
      <a href="/recipe/laravel-jetstream-prod" target="_blank">production environment recipe</a>.
    `
  },
  // laravel-minimal-devel
  {
    id: 'laravel-minimal-devel',
    recipeId: 'zeropsio/recipe-laravel-minimal-devel',
    importYaml: LARAVEL_MINIMAL_DEVEL_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'laravel-minimal-devel',
    logo: 'laravel',
    title: 'Basic Laravel — development / small production environment',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-laravel-minimal' }
    ],
    desc: `
      This recipe showcases a production-ready integration of basic Laravel apps to Zerops. The fact this environment
      is called <strong>development</strong> comes just from its minimal, cost-efficient resource allocation, selection of the
      <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Lightweight</a>
      core package and the fact you'd only start the services when you are actively working on the project.
      If you want to try the "production" environment setup with HA services and enterprise grade reliability deploy —
      <a href="/recipe/laravel-minimal-prod" target="_blank">production environment recipe</a>.
    `
  },
  // laravel-minimal-prod
  {
    id: 'laravel-minimal-prod',
    recipeId: 'zeropsio/recipe-laravel-minimal-prod',
    importYaml: LARAVEL_MINIMAL_PROD_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'laravel-minimal-prod',
    title: 'Basic Laravel — large scale production',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-laravel-minimal' }
    ],
    logo: 'laravel',
    desc: `
      This recipe showcases a <strong>production-ready</strong> integration of basic Laravel apps with Zerops, with all services set
      to high availability and <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Serious</a>
      core package used for enterprise grade reliability. If you want to try more cost-efficient environment deploy —
      <a href="/recipe/laravel-jetstream-devel" target="_blank">development / small production environment recipe</a>.
    `
  },
  // laravel-jetstream-local
  {
    id: 'laravel-jetstream-local',
    recipeId: 'zeropsio/recipe-laravel-jetstream-local',
    importYaml: LARAVEL_JETSTREAM_LOCAL_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'laravel-jetstream-local',
    logo: 'laravel-jetstream',
    title: 'Laravel Jetstream —&nbsp;local&nbsp;environment',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-laravel-jetstream' }
    ],
    desc: `
      This recipe showcases a production-ready integration of Jetstream apps to&nbsp;Zerops.
      The fact this environment is for <strong>local development</strong> comes just from its minimal,
      cost-efficient resource allocation, selection of the
      <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Lightweight</a>
      core package and the fact you'd only start the services when you are actively working on the project.
      If you want to try the "production" environment setup with HA services and enterprise grade reliability deploy —
      <a href="/recipe/laravel-jetstream-prod" target="_blank">production environment recipe</a>.
    `
  },
  // laravel-jetstream-devel
  {
    id: 'laravel-jetstream-devel',
    recipeId: 'zeropsio/recipe-laravel-jetstream-devel',
    importYaml: LARAVEL_JETSTREAM_DEVEL_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'laravel-jetstream-devel',
    title: 'Laravel Jetstream — development / small production environment',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-laravel-jetstream' }
    ],
    logo: 'laravel-jetstream',
    desc: `
      This recipe showcases a production-ready integration of Jetstream apps to Zerops. The fact this environment
      is called <strong>development</strong> comes just from its minimal, cost-efficient resource allocation and
      selection of the <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Lightweight</a>
      core package and the fact you'd only start the services when you are actively working on the project.
      If you want to try the "production" environment setup with HA services and enterprise grade reliability deploy —
      <a href="/recipe/laravel-jetstream-prod" target="_blank">production environment recipe</a>.
    `
  },
  // laravel-jetstream-prod
  {
    id: 'laravel-jetstream-prod',
    recipeId: 'zeropsio/recipe-laravel-jetstream-prod',
    importYaml: LARAVEL_JETSTREAM_PROD_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'laravel-jetstream-prod',
    title: 'Laravel Jetstream — large scale production',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-laravel-jetstream' }
    ],
    logo: 'laravel-jetstream',
    desc: `
      This recipe showcases a <strong>production-ready</strong> integration of Jetstream apps with Zerops, with all services set to high
      availability and <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Serious</a>
       core package used for enterprise grade reliability. If you want to try more cost-efficient environment deploy —
      <a href="/recipe/laravel-jetstream-devel" target="_blank">development / small production environment recipe</a>.
    `
  },
  // twillcms-local
  {
    id: 'twillcms-local',
    recipeId: 'zeropsio/recipe-twill-local',
    importYaml: TWILLCMS_LOCAL_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'twillcms-local',
    logo: 'twill',
    title: 'TwillCMS —&nbsp;local&nbsp;environment',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-twill' }
    ],
    desc: `
      This recipe showcases a production-ready integration of TwillCMS with Zerops.
      The fact this environment is for <strong>local development</strong> comes just from its minimal,
      cost-efficient resource allocation, selection of the
      <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Lightweight</a>
      core package and the fact you'd only start the services when you are actively working on the project.
      If you want to try the "production" environment setup with HA services and enterprise grade reliability deploy —
      <a href="/recipe/twillcms-prod" target="_blank">production environment recipe</a>.
    `
  },
  // twillcms-devel
  {
    id: 'twillcms-devel',
    recipeId: 'zeropsio/recipe-twill-devel',
    importYaml: TWILLCMS_DEVEL_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'twillcms-devel',
    logo: 'twill',
    title: 'TwillCMS — development / small production environment',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-twill' }
    ],
    desc: `
      This recipe showcases a production-ready integration of TwillCMS with Zerops. The fact this environment
      is called <strong>development</strong> comes just from its minimal, cost-efficient resource allocation and
      selection of the <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Lightweight</a>
      core package and the fact you'd only start the services when you are actively working on the project.
      If you want to try the "production" environment setup with HA services and enterprise grade reliability deploy —
      <a href="/recipe/twillcms-devel" target="_blank">production environment recipe</a>.
    `
  },
  // twillcms-prod
  {
    id: 'twillcms-prod',
    recipeId: 'zeropsio/recipe-twill-prod',
    importYaml: TWILLCMS_PROD_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'twillcms-prod',
    logo: 'twill',
    title: 'TwillCMS — large scale production',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-twill' }
    ],
    desc: `
      This recipe showcases a **production-ready** integration of Twill apps with Zerops, with all services set to high
      availability and <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Serious</a>
       core package used for enterprise grade reliability. If you want to try more cost-efficient environment deploy —
       <a href="/recipe/twillcms-devel" target="_blank">production environment recipe</a>.
    `
  },
  // filament-local
  {
    id: 'filament-local',
    recipeId: 'zeropsio/recipe-filament-local',
    importYaml: FILAMENT_LOCAL_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'filament-local',
    logo: 'filament',
    title: 'Filament —&nbsp;local&nbsp;environment',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-filament' }
    ],
    desc: `
      This recipe showcases a production-ready integration of Filament with Zerops.
      The fact this environment is for <strong>local development</strong> comes just from its minimal,
      cost-efficient resource allocation, selection of the
      <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Lightweight</a>
      core package and the fact you'd only start the services when you are actively working on the project.
      If you want to try the "production" environment setup with HA services and enterprise grade reliability deploy —
      <a href="/recipe/filament-prod" target="_blank">production environment recipe</a>.
    `
  },
  // filament-devel
  {
    id: 'filament-devel',
    recipeId: 'zeropsio/recipe-filament-devel',
    importYaml: FILAMENT_DEVEL_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'filament-devel',
    logo: 'filament',
    title: 'Filament — development / small production environment',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-filament' }
    ],
    desc: `
      This recipe showcases a production-ready integration of Filament with Zerops. The fact this environment
      is called <strong>development</strong> comes just from its minimal, cost-efficient resource allocation and
      selection of the <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Lightweight</a>
      core package and the fact you'd only start the services when you are actively working on the project.
      If you want to try the "production" environment setup with HA services and enterprise grade reliability deploy —
      <a href="/recipe/filament-prod" target="_blank">production environment recipe</a>.
    `
  },
  // filament-prod
  {
    id: 'filament-prod',
    recipeId: 'zeropsio/recipe-filament-prod',
    importYaml: FILAMENT_PROD_IMPORT_YAML,
    enableOnboarding: true,
    listed: false,
    slug: 'filament-prod',
    logo: 'filament',
    title: 'Filament — large scale production',
    repository: [
      { repository: 'https://github.com/zeropsio/recipe-filament' }
    ],
    desc: `
      This recipe showcases a <strong>production-ready</strong> integration of Filament apps with Zerops, with all services set to high
      availability and <a href="https://docs.zerops.io/features/pricing#understanding-projects" target="_blank">Serious</a>
       core package used for enterprise grade reliability. If you want to try more cost-efficient environment deploy —
       <a href="/recipe/filament-devel" target="_blank">development / small production environment recipe</a>.
    `
  },
  {
    id: 'directus',
    recipeId: 'zeropsio/recipe-directus',
    slug: 'directus',
    tag: 'Directus',
    logo: 'directus',
    icon: undefined,
    title: 'Directus',
    listed: true,
    category: RecipeCategoryTypes.ProjectUtility,
    importYaml: DIRECTUS_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-directus' }],
    desc: `<a target="_blank" href="https://directus.io">Directus</a> is a real-time API and app dashboard that instantly transforms any SQL database into a powerful REST/GraphQL API and no-code app. This recipe showcases how to run a Directus instance on Zerops, including advanced features like schema migrations, email templating, and Object Storage integration, making it suitable for production deployments of any scale.`,
    content: `
     <section>
    <h2>Recipe Features</h2>
    <ul>
      <li>Directus running on a load-balanced <strong>Zerops Node.js</strong> service</li>
      <li>Zerops <strong>PostgreSQL</strong> service as the database</li>
      <li>Zerops <strong>Object Storage</strong> (S3 compatible) service for file storage</li>
      <li>Automated schema migrations using Directus snapshots</li>
      <li>Custom email templates with Liquid templating</li>
      <li>Logs accessible through Zerops GUI</li>
      <li>Utilization of Zerops built-in <strong>environment variables</strong> system</li>
      <li>Zero downtime deployment with Zerops readiness checks</li>
      <li>Advanced app monitoring with health checks</li>
      <li>Sample collection setup with "images" demonstration</li>
    </ul>
  </section>

  <section>
    <h2>Schema Management</h2>
    <p>Directus provides a powerful schema snapshot system for maintaining consistency across environments:</p>
    <ol>
      <li>Make a copy of <code>.env.example</code> named <code>.env</code> and update <code>DB_PASSWORD</code> with credentials from GUI</li>
      <li>Install the Zerops CLI tool <code>zcli</code> and authenticate</li>
      <li>Generate a schema snapshot:</li>
    </ol>
    <pre><code>zcli vpn up
npx directus schema snapshot > snapshot.yaml</code></pre>
    <p>The recipe includes a demo "images" collection in <code>snapshot.yaml</code>. Snapshots are automatically applied during deployment via <code>run.initCommands</code>.</p>
  </section>

  <section>
    <h2>Email Templates</h2>
    <p>Customize Directus email notifications by adding templates to the <code>./templates</code> directory. Templates should correspond to <a href="https://github.com/directus/directus/tree/main/api/src/services/mail/templates">base Directus templates</a>.</p>
    <p>Example template structure:</p>
    <pre><code>./templates/
  └── user-invitation.liquid</code></pre>
  </section>

  <section>
    <h2>Project Customization</h2>
    <p>To adapt this recipe for your needs:</p>
    <ol>
      <li>Fork this repository</li>
      <li>Modify your Directus instance through the admin interface</li>
      <li>Create a new snapshot using the schema snapshot command</li>
      <li>Update environment variables and configurations as needed</li>
    </ol>
    <p>The resulting setup will provide a ready-to-deploy Directus instance with your specific configurations.</p>
  </section>

  <section>
    <h2>Production Deployment Guidelines</h2>

    <h4>Database Layer</h4>
    <ul>
      <li>Enable <strong>High Availability</strong> mode for PostgreSQL service</li>
      <li>Configure appropriate backup strategies</li>
    </ul>

    <h4>Cache Layer</h4>
    <ul>
      <li>Upgrade Redis to <strong>HA mode</strong> for enhanced reliability</li>
      <li>Zerops HA Redis (Valkey) implementation automatically handles master/replica routing:
        <ul>
          <li>Write operations are directed to master</li>
          <li>Read operations are distributed across all nodes</li>
          <li>No manual sentinel configuration required</li>
        </ul>
      </li>
    </ul>

    <h3>Multi-Container Setup</h3>
    <p>When scaling Directus across multiple containers, implement <a href="https://docs.directus.io/self-hosted/config-options.html#redis">Redis Configuration adjustments</a>.</p>

    <h3>Email Configuration</h3>
    <p>For production environments:</p>
    <ol>
      <li>Replace the development <em>mailpit</em> service with a production-ready email service</li>
      <li>Configure appropriate email credentials in environment variables</li>
      <li>Verify email template rendering and delivery</li>
    </ol>

    <h3>Schema Management</h3>
    <p>Implement robust schema version control:</p>
    <pre><code># Wrap schema applications in execOnce to prevent duplicate migrations on multiple containers.
zsc execOnce "migrate-\${appVersionId}" -- directus schema apply --yes snapshot.yaml</code></pre>
    <p>This approach ensures:</p>
    <ul>
      <li>One-time execution of migrations</li>
      <li>Version-specific schema updates</li>
      <li>Reliable deployment across environments</li>
    </ul>

    <h3>Pre-Production Checklist</h3>
    <ul>
      <li> Enable HA mode for PostgreSQL</li>
      <li> Configure HA Redis</li>
      <li> Remove development services (e.g., mailpit)</li>
      <li> Configure production email service</li>
      <li> Review and update environment variables</li>
      <li> Test schema migration process</li>
      <li> Verify backup procedures</li>
      <li> Review security settings</li>
    </ul>

    <blockquote>
      <p><strong>Note:</strong> These guidelines represent baseline production considerations. Additional optimizations may be necessary based on specific use cases and requirements.</p>
    </blockquote>
  </section>

    `,
  },
  // rag-starter
  {
    id: 'rag-starter',
    recipeId: 'zeropsio/recipe-rag-starter',
    slug: 'rag-starter',
    tag: 'RAG AI',
    logo: undefined,
    icon: 'smart_toy',
    title: 'RAG Infrastructure Example',
    listed: true,
    category: RecipeCategoryTypes.Other,
    importYaml: RAG_STARTER_IMPORT_YAML,
    repository: [{ repository: 'https://github.com/zeropsio/recipe-rag-starter' }],
    desc: 'A complete RAG (Retrieval Augmented Generation) infrastructure example demonstrating how Zerops handles the complexity of AI/LLM applications with vector database, caching, queues, and object storage.',
    content: `
    <section>
      <h2>Recipe features</h2>
      <ul>
        <li><strong>Qdrant vector database</strong> for storing and searching embeddings</li>
        <li><strong>PostgreSQL 16</strong> for metadata storage</li>
        <li><strong>Valkey/Redis</strong> for caching layer</li>
        <li><strong>NATS</strong> message queue for async processing</li>
        <li><strong>S3-compatible object storage</strong> for document files</li>
        <li><strong>FastAPI</strong> service with auto-scaling</li>
        <li><strong>Worker</strong> service for document processing</li>
        <li><strong>Web dashboard</strong> for document upload and search</li>
      </ul>
    </section>

    <section>
      <h2>What This Demonstrates</h2>
      <p>This is a hello-world demonstration showing how Zerops handles the infrastructure complexity of RAG applications — perfect for understanding integration patterns for your own AI projects.</p>

      <h3>One-Click Infrastructure</h3>
      <p>Deploy 8 interconnected services in 60 seconds with automatic service discovery and configuration.</p>

      <h3>Service Auto-Configuration</h3>
      <p>See how Zerops automatically wires services together using environment variables — no manual configuration needed.</p>

      <h3>Development Workflow</h3>
      <p>Connect to your cloud services locally using <code>zcli vpn up</code> for seamless development.</p>
    </section>

    <section>
      <h2>Production vs. development</h2>
      <p>The recipe includes production-ready configuration with HA (High Availability) mode enabled for all services:</p>
      <ul>
        <li>Multiple containers for API and processor services</li>
        <li>HA mode for PostgreSQL, Valkey, NATS, and Qdrant</li>
        <li>Load balancing and auto-scaling capabilities</li>
        <li>Zero-downtime deployments</li>
      </ul>

      <h3>Architecture Pattern</h3>
      <p>This example shows the complete infrastructure pattern for modern AI applications:</p>
      <ul>
        <li>Async processing with message queues</li>
        <li>Vector similarity search with Qdrant</li>
        <li>Caching strategies for performance</li>
        <li>Service discovery and inter-service communication</li>
        <li>Object storage for document files</li>
      </ul>
    </section>
    `,
  }
];
